const es = {
  "nav.home": "Inicio",
  "nav.browse": "Ver ofertas",
  "nav.nearExpiry": "Por vencer",
  "nav.categories": "Categorías",
  "nav.businesses": "Negocios",
  "nav.favourites": "Favoritos",
  "nav.following": "Siguiendo",
  "follows.title": "Siguiendo",
  "follows.subtitle": "Todas las tiendas y lugares que sigues, en un solo lugar. Te avisamos cuando publiquen algo nuevo.",
  "follows.businesses": "Tiendas que sigues ({n})",
  "follows.places": "Lugares que sigues ({n})",
  "follows.followPlace": "Seguir este lugar",
  "follows.following": "Siguiendo",
  "follows.nowFollowing": "Siguiendo {name}",
  "follows.unfollowed": "Dejaste de seguir {name}",
  "follows.placeNudge": "Te avisaremos cuando cualquier tienda de aquí publique una oferta.",
  "follows.signIn": "Inicia sesión para seguir tiendas y lugares",
  "follows.createAccount": "Crear una cuenta gratis",
  "follows.emptyTitle": "Todavía no sigues a nadie",
  "follows.emptyBody": "Sigue una tienda o una plaza y las ofertas nuevas te llegarán solas.",
  "nav.myDeals": "Mis ofertas",
  "nav.lytemap": "LyteMap",
  "nav.postDeal": "Publicar oferta",
  "nav.analytics": "Analíticas",
  "nav.admin": "Admin",
  "nav.ourStory": "Nuestra historia",
  "nav.myAccount": "Mi cuenta",
  "nav.pricing": "Precios",

  "brand.tagline": "Ahorra más. Desperdicia menos.",

  "sidebar.businessLogin": "Entrar",
  "sidebar.signupFree": "¿Nuevo aquí? Regístrate gratis",
  "sidebar.proActive": "Pro activo",
  "sidebar.until": "Hasta {date}",
  "sidebar.growPro": "Crece con Pro",
  "sidebar.growProDesc": "Colocación destacada, ofertas ilimitadas y analíticas completas.",
  "sidebar.goPremium": "Hazte Premium",

  "topbar.searchPlaceholder": "Busca ofertas, negocios o categorías...",
  "topbar.aiPlaceholder": "Pregunta a la IA: cena barata cerca…",
  "topbar.askAi": "Pregunta IA",
  "topbar.nearMe": "Cerca de mí",
  "topbar.anywhere": "En todas partes",
  "topbar.country": "País",
  "topbar.city": "Ciudad",
  "topbar.allCities": "Todas las ciudades",
  "topbar.useMyLocation": "Usar mi ubicación",
  "topbar.privacyNote": "Usamos la ubicación de tu dispositivo, no tu dirección IP: es privada y precisa incluso con una VPN.",
  "topbar.typePlace": "o escribe una ciudad o lugar…",
  "topbar.clearEverywhere": "Borrar — mostrar ofertas en todas partes",
  "topbar.notifications": "Notificaciones",
  "topbar.more": "Más opciones",
  "topbar.darkMode": "Modo oscuro",
  "topbar.lightMode": "Modo claro",
  "topbar.recent": "{n} recientes",
  "topbar.noNotifs": "Aún no hay notificaciones.",
  "topbar.viewAllDeals": "Ver todas las ofertas",
  "topbar.hello": "Hola, {name}",
  "topbar.login": "Entrar",
  "topbar.try": "Prueba:",

  "footer.contact": "Contacto",
  "footer.terms": "Términos de uso",
  "footer.privacy": "Política de privacidad",
  "footer.pricing": "Precios",
  "footer.refunds": "Política de reembolsos",

  "home.todaysBest": "Las mejores ofertas de hoy",
  "home.upToOff": "Hasta {n}% de descuento",
  "home.explore": "Explorar ofertas",
  "home.browseCategories": "Ver categorías",
  "home.eduHeroA": "Aprende por",
  "home.eduHeroB": "menos.",
  "home.eduHeroSub": "Encuentra tutorías, cursos y clases cerca de ti, a precios que valen la pena.",
  "home.liveDeals": "{n} ofertas activas",
  "home.categoriesCount": "{n} categorías",
  "home.shopByCategory": "Compra por categoría",
  "home.viewAll": "Ver todo",
  "home.featuredDeals": "⭐ Ofertas destacadas",
  "home.featuredNearYou": "⭐ Destacadas",
  "home.featuredIn": "⭐ Destacadas en {place}",
  "home.topDeals": "Mejores ofertas",
  "home.topDealsNear": "Mejores ofertas cerca de {place}",
  "home.topDealsNearYou": "Mejores ofertas cerca de ti",
  "home.locPromptTitle": "Ve ofertas justo a tu alrededor",
  "home.locPromptDesc": "Comparte tu ubicación y pondremos las ofertas más cercanas —con distancias— al inicio de tu página.",
  "home.shareLocation": "Compartir ubicación",
  "home.locating": "Localizando…",

  "tourist.visitingTitle": "¿De visita por la zona?",
  "tourist.visitingDesc": "Activa el Modo Turista para ver las mejores ofertas cerca, en tu moneda y con indicaciones en un toque.",
  "tourist.imVisiting": "Estoy de visita",

  "rail.yourLocation": "Tu ubicación",
  "rail.change": "Cambiar",
  "rail.featuredDeal": "Oferta destacada",
  "rail.viewDeal": "Ver oferta",
  "rail.nearExpiry": "Por vencer",
  "rail.lastChance": "(¡Última oportunidad!)",
  "rail.viewAll": "Ver todo",
  "rail.noNearExpiry": "No hay artículos por vencer ahora mismo.",
  "rail.getAlerts": "Recibe alertas de ofertas",
  "rail.getAlertsDesc": "¡Sé el primero en enterarte de nuevas ofertas y ventas flash!",
  "rail.enableAlerts": "Activar alertas",

  "lang.label": "Idioma",

  "cat.All": "Todo",
  "cat.Food": "Comida",
  "cat.Drinks": "Bebidas",
  "cat.Health": "Salud",
  "cat.Events": "Eventos",
  "cat.Lodging": "Alojamiento",
  "cat.Services": "Servicios",
  "cat.Pets": "Mascotas",
  "cat.Beauty": "Belleza",
  "cat.Tech": "Tecnología",
  "cat.Near Expiry": "Por vencer",
  "cat.Upcoming": "Próximas",
  "cat.Automotive": "Automoción",
  "cat.Fitness": "Fitness",
  "cat.Clothing": "Ropa",
  "cat.Plants": "Plantas",
  "cat.Education": "Educación",
  "cat.Farm & Livestock": "Granja y Ganado",
  "cat.Other": "Otros",
  "cat.More": "Más",
  "time.expired": "Caducada",
  "time.dLeft": "{d}d {h}h restantes",
  "time.hLeft": "{h}h {m}m restantes",
  "time.mLeft": "{m}m {s}s restantes",
  "card.save": "Ahorra {amount}",
  "card.review": "{n} reseña",
  "card.reviews": "{n} reseñas",
  "map.dealsHere": "{n} ofertas aquí",
  "map.dealsAtSpot": "{n} ofertas en este punto",
  "map.businessesHere": "{n} negocios",
  "map.endsSoon": "termina pronto",
  "map.viewDeal": "Ver oferta",
  "map.directions": "Cómo llegar",
  "map.branchOf": "1 de {n} sucursales",
  "map.approx": "{amount} aprox.",
  "map.subtitleGps": "Ofertas cerca de {place} — busca otro lugar en la barra superior para mover el mapa.",
  "map.subtitle": "Comparte tu ubicación para ver al instante ofertas cerca de ti, o busca una ciudad / elige un país en la barra superior.",
  "map.yourLocation": "tu ubicación",
  "map.jumpTo": "Ir a:",
  "map.autoDetected": "Mostrando ofertas en {country} — ¿no es correcto?",
  "map.change": "Cambiar",
  "map.maybeLaterBrowse": "Quizás más tarde — explorar {place}",
  "map.allDeals": "todas las ofertas",
  "map.endingSoon": "Terminan pronto",
  "map.inView": "En vista",
  "map.all": "Todo",
  "map.inViewCount": "{n} de {m} en vista",
  "map.nearbyCount": "{n} de {m} cerca",
  "map.dealCount": "{n} ofertas",
  "map.dealCountNearby": "{n} ofertas cerca",
  "map.fitAll": "Ver todas las ofertas",
  "map.geoTitle": "Ve ofertas cerca de ti",
  "map.geoDesc": "Comparte tu ubicación y te mostramos al instante las mejores ofertas a tu alrededor en el mapa.",
  "map.emptyFilter": "Ninguna oferta coincide con este filtro por aquí.",
  "map.emptyGps": "Aún no hay ofertas cerca de esta ubicación — prueba otro lugar o explora por país.",
  "map.emptyCountry": "Aún no hay ofertas en {country}.",
  "map.emptyInView": "No hay ofertas en esta parte del mapa.",
  "map.zoomOut": "Aleja para ver las {n}",
  "map.myLocation": "Tu ubicación",
  "map.expandMap": "Ampliar mapa",
  "map.showList": "Ver ofertas",
  "map.openNow": "Abierto ahora",
  "map.openBadge": "Abierto ahora",
  "map.closedBadge": "Cerrado ahora",
  "map.heatmap": "Mapa de ahorros",
  "map.heatLegend": "Los mayores descuentos de esta zona",
  "map.shareView": "Compartir esta vista",
  "map.shareTitle": "Ofertas en LytePress",
  "map.linkCopied": "Enlace copiado: compártelo donde quieras",
  "map.sharedView": "Mostrando una vista compartida del mapa",
  "map.world": "Mundo",
  "map.shopsHere": "{n} tiendas",
  "map.sharedAddress": "{n} tiendas en esta dirección",
  "spot.eyebrow": "Todas las ofertas en esta dirección",
  "spot.fallbackTitle": "Esta dirección",
  "spot.dealCount": "{n} ofertas",
  "spot.visitShop": "Ver tienda",
  "spot.seeAll": "Ver todo",
  "spot.backToMap": "Volver a LyteMap",
  "spot.gone": "No hay ofertas activas en esta dirección ahora mismo.",
  "spot.share": "Compartir estas ofertas",
  "spot.shareCopied": "Copiado: pégalo donde quieras",
  "spot.shareHead": "{name}: {shops} tiendas, {deals} ofertas ahora en LytePress:",
  "spot.shareMore": "…y {n} más",
  "map.noDealsRegion": "Aún no hay ofertas en esta región.",
  "invite.cta": "Invitar a un negocio",
  "invite.title": "Invita a un negocio a LytePress",
  "invite.subtitle": "¿Conoces una tienda con ofertas que merecen compartirse? Dinos y la invitamos.",
  "invite.namePh": "Nombre del negocio",
  "invite.cityPh": "Ciudad o pueblo",
  "invite.countryPh": "País",
  "invite.emailPh": "Su correo (opcional)",
  "invite.notePh": "¿Por qué deberían conocerla los compradores? (opcional)",
  "invite.submit": "Enviar invitación",
  "invite.privacy": "Solo usamos estos datos para invitar al negocio. No se crea ninguna cuenta.",
  "invite.sentEmail": "Invitación enviada por correo",
  "invite.logged": "¡Gracias, anotado!",
  "invite.nudge": "Un mensaje personal funciona mejor. Envíales esto:",
  "invite.shareMsg": "¡Hola {name}! Publica tus ofertas en LytePress para que los compradores cercanos te encuentren; empezar es gratis: {url}",
  "invite.whatsapp": "Enviar por WhatsApp",
  "invite.copy": "Copiar mensaje",
  "invite.failed": "No pudimos enviar la invitación. Inténtalo de nuevo.",
  "map.citiesIn": "Ciudades en {country}:",
  "map.allOf": "Todo {country}",
  "map.moreCountries": "+{n} países más",
  "map.fewerCountries": "Mostrar menos",
  "map.countriesIn": "Países en {region}:",
  "reg.Caribbean": "Caribe",
  "reg.North America": "América del Norte",
  "reg.Central America": "América Central",
  "reg.South America": "América del Sur",
  "reg.Europe": "Europa",
  "reg.Middle East": "Oriente Medio",
  "reg.Africa": "África",
  "reg.Asia": "Asia",
  "reg.Oceania": "Oceanía",
  "reg.Other": "Otros",
  "pd.postTitle": "Publicar oferta",
  "pd.editTitle": "Editar oferta",
  "pd.dealTitle": "Título de la oferta",
  "pd.dealTitlePh": "ej. Pizzas grandes 2x1",
  "pd.photos": "Fotos de la oferta",
  "pd.photosHint": "(hasta 6 - los compradores pueden deslizarlas)",
  "pd.cover": "Portada",
  "pd.category": "Categoría",
  "pd.currency": "Moneda",
  "pd.redeemHow": "¿Cómo se canjea esta oferta?",
  "pd.inPerson": "En persona",
  "pd.onlineOnly": "Solo en línea",
  "pd.onlineNote": "No necesita pin en el mapa - compradores de todo el mundo la verán",
  "pd.promoLabel": "Código promocional que usarán al pagar",
  "pd.promoHint": "Se mantiene oculto hasta que un comprador consigue la oferta; luego se muestra con un botón para copiarlo. Asegúrate de que funcione en tu web.",
  "pd.whichLocations": "¿A qué sucursales aplica esta oferta?",
  "pd.pinLabel": "Marca la ubicación de la oferta en el mapa",
  "pd.description": "Descripción",
  "pd.descriptionPh": "Describe la oferta...",
  "pd.dealType": "Tipo de oferta",
  "pd.percentOff": "Porcentaje de descuento (%)",
  "pd.setPrice": "Precio fijo",
  "pd.originalPrice": "Precio original ({sym})",
  "pd.dealPrice": "Precio de oferta ({sym})",
  "pd.discountPct": "Descuento (%)",
  "pd.terms": "Términos y condiciones",
  "pd.endsOn": "Termina el",
  "pd.lastChance": "Última oportunidad",
  "pd.lastChanceNote": "es automática: tu oferta entra en esa lista sola cuando le quedan menos de 48 horas.",
  "pd.shortDated": "Producto próximo a caducar",
  "pd.bestBefore": "Consumir antes del (opcional)",
  "pd.feature": "Destacar esta oferta",
  "pd.timezone": "Zona horaria",
  "pd.publishAt": "Publicar el",
  "pd.publishHint": "Déjalo vacío para publicar ahora mismo.",
  "pd.publish": "Publicar oferta",
  "pd.saveChanges": "Guardar cambios",
  "pd.promoNeeded": "Falta el código promocional",
  "pd.promoNeededMsg": "Las ofertas en línea se canjean con un código promocional: añade el código que deben usar los compradores.",
  "pd.addDiscount": "Añade un descuento",
  "pd.addDiscountMsg": "Indica el porcentaje de descuento de esta oferta (1-100).",
  "pd.subtitle": "Comparte una promoción o una oferta próxima a caducar con tu comunidad.",
  "pd.upload": "Toca para subir o tomar fotos",
  "pd.uploadHint": "JPG, PNG o WEBP de hasta 8MB cada una",
  "pd.branchHint": "Marca para incluir una ubicación guardada. También puedes añadir un pin personalizado en el mapa.",
  "picker.searchPh": "Busca una dirección o lugar...",
  "picker.find": "Buscar",
  "picker.gps": "Usar mi GPS",
  "picker.hint": "Busca, usa el GPS o toca el mapa para colocar un pin. Arrastra el pin para ajustar el punto exacto.",
  "picker.namedPre": "Hemos nombrado este pin",
  "picker.editName": "¿No es correcto? Toca para editar el nombre que verán los compradores",
  "pd.editSubtitle": "Ajusta el precio, las fechas o los detalles y publica tu oferta actualizada.",
  "pd.uploading": "Subiendo...",
  "pd.pinHint": "- añade un pin por cada sitio donde esté disponible esta oferta. Las ubicaciones vienen de tu perfil de negocio (una oferta puede cambiarlas abajo).",
  "pd.codeReq": "Exigir un código de canje en la tienda",
  "pd.codeReqHint": "Los compradores reciben un código y un QR únicos para mostrar al pagar. Tú lo confirmas desde Mi cuenta: así sabes exactamente cuántos clientes te envió LytePress.",
  "pd.schedule": "Programar cuándo se publica",
  "pd.scheduleHint": "Publicación automática a una hora exacta en la zona horaria que elijas. Déjalo apagado para publicar ahora. El vencimiento usa la fecha de Termina el de arriba.",
  "pd.branchFooter": "Opcional: si te lo saltas, colocaremos la oferta en la dirección registrada de tu negocio ({place}). Gestiona tu horario en",
  "pd.beating": "Superando a {rival}",
  "pd.beatingMsg": "Su '{title}' tiene un {rivalDiscount}% de descuento: hemos preparado una oferta mejor con un {discount}%. Ajústala y publícala para ganar al comprador.",
  "pd.termsDefault": "Válido hasta agotar existencias. No combinable con otras ofertas.",
  "common.percentOff": "{n}% de dto.",
  "common.tryAgain": "Inténtalo de nuevo.",

  "browse.title": "Ver ofertas",
  "browse.nearYou": "Ofertas cerca de ti",
  "browse.nearPlace": "Ofertas cerca de {place}",
  "browse.sortedFrom": "Ordenadas por distancia desde {place}.",
  "browse.bestLocal": "Los mejores ahorros locales en {place}.",
  "browse.worldwide": "Grandes ofertas de todo el mundo.",
  "browse.radius": "Radio de distancia",
  "browse.openNow": "Abierto ahora",
  "browse.online": "En línea",
  "browse.shortDated": "Próximo a caducar",
  "browse.clearSearch": "Borrar búsqueda",
  "browse.aiNoMatch": "Ninguna oferta coincide con esa búsqueda. Prueba a reformularla — por ejemplo “ofertas de restaurantes por menos de $20” o “electrónica cerca de mí”.",
  "browse.aiUnavailable": "La búsqueda con IA no está disponible ahora — te mostramos los resultados normales.",
  "browse.searchFilters": "Filtros de tu búsqueda:",
  "browse.noDeals": "Todavía no hay ofertas aquí",
  "browse.noMatch": "Nada coincide con “{q}”. Prueba otras palabras u otra categoría.",
  "browse.closestMatches": "Sin coincidencia exacta para “{q}”: estas son las ofertas más cercanas.",
  "browse.didYouMean": "Buscar “{q}” en su lugar",
  "trending.label": "Tendencia cerca de ti",
  "saved.cta": "Guardar esta búsqueda",
  "saved.saved": "Búsqueda guardada",
  "saved.section": "Búsquedas guardadas ({n})",
  "saved.done": "Guardado “{q}”",
  "saved.doneBody": "Te avisaremos cuando aparezca una oferta que coincida.",
  "saved.removed": "Eliminado “{q}”",
  "saved.signIn": "Inicia sesión para guardar búsquedas",
  "browse.browseCats": "Ver categorías",
  "browse.emptyOpenNow": "Ningún negocio abierto ahora mismo tiene ofertas. Prueba a desactivar “Abierto ahora”.",
  "browse.emptyShortDated": "No hay productos próximos a caducar ahora — vuelve pronto, aparecen cuando las tiendas rebajan stock cerca de su fecha.",
  "browse.emptyOnline": "Aún no hay ofertas solo en línea — desactiva el filtro En línea para ver ofertas cerca de ti.",
  "browse.emptyRadius": "No hay ofertas a menos de {radius} de ti. Prueba a ampliar el radio.",
  "browse.emptyRadiusPlace": "No hay ofertas a menos de {radius} de {place}. Prueba a ampliar el radio.",
  "browse.emptyDefault": "Ninguna oferta coincide con tus filtros. Prueba a quitar un filtro o explora otra categoría.",
  "browse.firstBusiness": "Sé el primer negocio en {place}",
  "browse.firstBusinessMsg": "Aquí nadie ha publicado todavía — la primera oferta se lleva a todos los compradores que llegan, y tu negocio queda solo en lo más alto del mapa.",
  "browse.postFirst": "Publica la primera oferta",
  "browse.yourArea": "tu zona",

  "card.lastChance": "Última oportunidad",
  "card.shortDated": "Próximo a caducar",
  "card.online": "Oferta en línea",
  "card.directions": "Cómo llegar",
  "card.favourite": "Añadir a favoritos",
  "card.inYourCurrency": "en tu moneda",
  "card.locations": "{n} ubicaciones",

  "fav.title": "Favoritos",
  "fav.subtitle": "Ofertas que guardaste para después.",
  "fav.emptyTitle": "Aún no tienes favoritos",
  "fav.emptyMsg": "Toca el corazón en cualquier oferta para guardarla aquí.",
  "fav.browse": "Ver ofertas",

  "cats.heading": "¿Qué estás buscando?",
  "cats.allDeals": "Todas las ofertas",
  "cats.endingSoon": "Terminan pronto",

  "mydeals.guestTitle": "Tus ofertas guardadas viven aquí",
  "mydeals.guestMsg": "Entra gratis y cada oferta que consigas — códigos, pases QR y promociones — se guarda aquí en todos tus dispositivos, con recordatorios antes de que terminen.",
  "mydeals.createAccount": "Crear cuenta gratis",
  "mydeals.businessTitle": "Mis ofertas es para compradores",
  "mydeals.businessMsg": "Gestiona las ofertas que has publicado desde tu panel.",
  "mydeals.goDashboard": "Ir al panel",
  "mydeals.title": "Mis ofertas",
  "mydeals.subtitle": "Todas las ofertas que has conseguido — muéstralas en el negocio para canjearlas.",
  "mydeals.emptyTitle": "Aún no has conseguido ofertas",
  "mydeals.emptyMsg": "Toca \"Conseguir oferta\" en cualquier promoción y aparecerá aquí con tu código, una cuenta atrás y la ruta hasta la tienda.",
  "mydeals.ready": "Listas para canjear",
  "mydeals.nothingWaiting": "Nada pendiente —",
  "mydeals.grabNew": "consigue una nueva oferta",
  "mydeals.redeemedOn": "canjeada el {date}",
  "mydeals.youSavedAmount": "ahorraste {amount}",
  "mydeals.youSavedTotal": "Has ahorrado {amount}",
  "mydeals.redeemed": "Canjeadas",
  "mydeals.ended": "Finalizadas",
  "mydeals.dealEnded": "Esta oferta ha terminado",
  "mydeals.toRedeem": "{time} para canjear",
  "mydeals.noExpiry": "Sin vencimiento — canjea cuando quieras",
  "mydeals.showAtCheckout": "Muéstralo al pagar",
  "mydeals.useOnlineCode": "Usa tu código en su tienda en línea",
  "mydeals.showAtBusiness": "Muestra esta oferta en {business}",
  "mydeals.shortDated": "Próximo a caducar",
  "mydeals.useBy": "consumir antes del {date}",
  "mydeals.copy": "Copiar",
  "mydeals.codeCopied": "Código copiado",
  "mydeals.pasteAt": "Pega {code} al pagar.",
  "mydeals.yourCode": "Aquí está tu código",
  "mydeals.undone": "Oferta deshecha",
  "mydeals.undoneMsg": "“{title}” se quitó de Mis ofertas.",
  "mydeals.undoFailed": "No se pudo deshacer",

  "nearexp.subtitle": "Consíguelas antes de que desaparezcan — ahorra mucho y reduce el desperdicio.",
  "nearexp.grab": "Conseguir oferta",
  "nearexp.emptyTitle": "Nada a punto de vencer ahora",
  "nearexp.emptyMsg": "Ahora no hay ofertas de última oportunidad. Vuelve pronto — aparecen cuando las ofertas se acercan a su fecha final.",
  "nearexp.browseAll": "Ver todas las ofertas",

  "deal.notFound": "Oferta no encontrada.",
  "deal.back": "Volver a las ofertas",
  "deal.featured": "DESTACADA",
  "deal.zoom": "Ver imagen completa",
  "deal.zoomHint": "Pellizca o toca dos veces para ampliar",
  "deal.zoomReset": "Toca dos veces para restablecer",
  "deal.translate": "Traducir",
  "deal.translated": "Traducido",
  "deal.translateFail": "Traducción no disponible",
  "deal.inYourCurrency": "en tu moneda",
  "deal.shortDatedTitle": "Producto próximo a caducar",
  "deal.shortDatedUseBy": "consumir antes del {date}",
  "deal.shortDatedNote": "Está en perfecto estado, con precio rebajado para que se use en vez de tirarse. Comprueba que la fecha te sirve antes de comprar.",
  "deal.onlineTitle": "Oferta en línea",
  "deal.onlineMsg": "No hace falta ir a la tienda — consigue la oferta para ver tu código promocional y úsalo en la tienda en línea de {business}.",
  "deal.onlineWorldwide": "Disponible para compradores de cualquier parte del mundo.",
  "deal.onlineBadge": "Oferta en línea · canjea donde estés",
  "deal.grab": "Conseguir oferta",
  "deal.getCode": "Obtener mi código de canje",
  "deal.getPromo": "Obtener mi código promocional",
  "deal.signInGrab": "Entra gratis y consigue la oferta",
  "deal.grabbed": "¡Oferta conseguida!",
  "deal.promoUse": "Usa este código promocional en la tienda en línea de {business}:",
  "deal.copyCode": "Copiar código",
  "deal.savedInPre": "Guardada en",
  "deal.savedUntilExpiry": "hasta que caduque.",
  "deal.visitToRedeem": "Visita {business} en {location} para canjear esta oferta antes de que termine.",
  "deal.loginHint": "Cuenta gratuita de comprador · 10 segundos · te traemos de vuelta aquí",
  "deal.signInToGrab": "Entra para conseguir esta oferta",
  "deal.signInToGrabMsg": "Crea una cuenta gratuita de comprador — te traemos de vuelta a esta oferta.",
  "deal.couldNotGrab": "No se pudo conseguir la oferta",
  "deal.codeCopied": "Código copiado",
  "deal.pasteAt": "Pega {code} al pagar.",
  "deal.grabUndone": "Oferta deshecha",
  "deal.grabUndoneMsg": "Sin problema — la oferta sigue aquí si cambias de opinión.",
  "deal.mapUnavailable": "Mapa no disponible",
  "deal.location": "Ubicación",
  "deal.availableAt": "Disponible en {n} ubicaciones",
  "deal.directions": "Cómo llegar",
  "deal.terms": "Términos y condiciones",
  "deal.staffCode": "El personal de {business} introducirá este código para aplicar tu descuento. Un solo uso — vuelve a encontrarlo en",
  "deal.myDeals": "Mis ofertas",
  "deal.views": "{n} vistas",

  "auth.verify": "Verificar",
  "auth.login": "Entrar",
  "auth.welcomeBack": "Bienvenido de nuevo a LytePress.",
  "auth.email": "Correo electrónico",
  "auth.password": "Contraseña",
  "auth.forgot": "¿Olvidaste tu contraseña?",
  "auth.newShopper": "¿Nuevo comprador?",
  "auth.createFree": "Crea una cuenta gratis",
  "auth.areBusiness": "¿Eres un negocio?",
  "auth.registerBusiness": "Registra tu negocio",
  "auth.welcomeBackToast": "¡Bienvenido de nuevo!",
  "auth.signedInAs": "Has entrado como {name}",
  "auth.loginFailed": "Error al entrar",
  "auth.invalidCreds": "Credenciales incorrectas",
  "auth.mfaTitle": "Verificación en dos pasos",
  "auth.mfaMsg": "Introduce el código de 6 dígitos de tu app de autenticación, o usa un código de recuperación.",
  "auth.mfaPlaceholder": "123456 o código de recuperación",
  "auth.trustDevice": "Confiar en este dispositivo 30 días",
  "auth.skip2fa": "(sin 2FA la próxima vez)",
  "auth.signupTitle": "Crea tu cuenta gratis",
  "auth.signupMsg": "Sigue a tus negocios favoritos y recibe un aviso en el momento en que publiquen una oferta.",
  "auth.yourName": "Tu nombre",
  "auth.passwordMin": "Contraseña (mín. 6 caracteres)",
  "auth.agreeTo": "Al crear una cuenta aceptas nuestros",
  "auth.and": "y la",
  "auth.haveAccount": "¿Ya tienes cuenta?",
  "auth.logIn": "Entrar",
  "auth.signupFailed": "Error al registrarse",
  "auth.welcomeToLyte": "¡Bienvenido a LytePress!",
  "qa.fixTitle": "Primero corrijamos esto",
  "qa.uploadBlocked": "Foto no aceptada",
  "qa.pending": "Enviado para revisión",
  "qa.pendingMsg": "Tu oferta se publicará en cuanto nuestro equipo la apruebe.",
  "qa.watchNotice": "Revisamos tus ofertas antes de publicarlas. Publica con normalidad: suelen aprobarse en pocas horas.",
  "qa.title_short": "Ponle un título real a la oferta (al menos 6 caracteres) para que los compradores sepan qué es.",
  "qa.title_long": "Ese título es demasiado largo: mantenlo por debajo de 90 caracteres.",
  "qa.title_caps": "Por favor, no escribas el título EN MAYÚSCULAS: parece spam.",
  "qa.title_emoji": "Demasiados emojis en el título: usa dos como máximo.",
  "qa.desc_short": "Añade una descripción corta (al menos 20 caracteres) que explique qué reciben los compradores.",
  "qa.banned": "Ese texto no está permitido en LytePress. Elimina el contenido restringido o para adultos.",
  "qa.links": "No se permiten enlaces ni redes sociales en la descripción: los compradores te contactan desde tu perfil, donde ya están tus datos.",
  "qa.phone": "No incluyas números de teléfono en la descripción: añádelos al perfil de tu negocio.",
  "qa.price_invalid": "El precio y el precio anterior deben ser números.",
  "qa.disc_high": "Un descuento superior al {max}% no resulta creíble y los compradores lo denuncian. Corrígelo, por favor.",
  "qa.was_low": "El precio anterior debe ser mayor que el precio de la oferta.",
  "qa.disc_mismatch": "Tu % de descuento no coincide con los precios: {price} desde {was} es un {computed}% de descuento, no un {discount}%.",
  "qa.dup_title": "Ya tienes una oferta activa con este mismo título: edita esa o cambia este título.",
  "qa.img_small": "Esa foto solo mide {w}×{h}px y se vería borrosa. Sube al menos {minW}×{minH}px.",
  "qa.img_blank": "Esa imagen parece vacía o de un solo color. Sube una foto real de la oferta.",
  "qa.img_blurry": "Esa foto parece desenfocada. Sube una más nítida para que se vea bien la oferta.",
  "qa.img_unreadable": "No pudimos leer esa imagen. Sube una foto JPG, PNG o WebP.",
  "qa.img_duplicate": "Otra empresa ya usa esa foto en LytePress. Sube tu propia foto de la oferta.",
  "qa.ai_blocked": "Nuestro control de contenido bloqueó esta oferta (contenido para adultos o explícito). Si crees que es un error, escribe a support@lytepress.com.",
  "qa.planLimit": "Has alcanzado el límite de ofertas de tu plan",
  "qa.seePlans": "Ver planes",
  "qa.coachGood": "Se ve genial",
  "qa.coachChecking": "Comprobando la foto…",
  "qa.coachSmall": "Demasiado pequeña ({w}×{h}px): necesita {minW}×{minH}px",
  "qa.coachBlurry": "Parece desenfocada: prueba con una más nítida",
  "qa.coachBlank": "Parece vacía: sube una foto real de la oferta",
  "invite.signInTitle": "Inicia sesión para nominar una tienda",
  "invite.signInMsg": "Crear una cuenta gratis toma segundos y mantiene las invitaciones auténticas.",
  "prc.badge": "Planes para negocios",
  "prc.h1": "Crece más rápido con LytePress",
  "prc.sub": "Publica más ofertas, aparece primero y comprueba cómo te comparas con la tienda de al lado.",
  "prc.chipAnalytics": "Analíticas completas",
  "prc.yourPlan": "Tu plan: {plan}",
  "prc.dealsUsed": "{used} de {limit} ofertas activas usadas",
  "prc.unlimited": "ilimitadas",
  "prc.monthly": "Mensual",
  "prc.yearly": "Anual",
  "prc.save17": "ahorra 17%",
  "prc.free": "Gratis",
  "prc.freeSub": "Para empezar",
  "prc.f3": "Seguimiento de visitas",
  "prc.currentPlan": "Tu plan actual",
  "prc.pro": "Pro",
  "prc.perYear": "/ año",
  "prc.per30": "/ 30 días",
  "prc.proYearNote": "Unos {monthly}/mes: 2 meses gratis",
  "prc.proMonthNote": "o {yearly}/año: ahorra 17%",
  "prc.p2": "Analíticas completas y comparativa con la competencia",
  "prc.p4": "Avisa de nuevas ofertas a todos tus seguidores",
  "prc.plus": "Elite",
  "prc.plusYearNote": "Son {monthly}/mes: 2 meses gratis",
  "prc.plusMonthNote": "Para tiendas con volumen o varias sucursales",
  "prc.activeLife": "Activo de por vida",
  "prc.renewsOn": "Se renueva el {date}",
  "prc.endsOn": "Termina el {date}",
  "prc.cancelRenewPro": "Cancelar renovación (conservas Pro hasta que acabe)",
  "prc.cancelRenew": "Cancelar renovación automática",
  "prc.resumeRenew": "Reactivar renovación automática",
  "prc.goYearly": "Pasar a anual: {price}",
  "prc.goMonthly": "Pasar a mensual: {price}",
  "prc.guarantee": "Devolución en 14 días:",
  "prc.guaranteeLink": "sin preguntas",
  "prc.boostTitle": "¿Necesitas un empujón?",
  "prc.myAccount": "Mi cuenta",
  "prc.boostRefundPre": "Reembolsable al 100% antes de que empiece la colocación: consulta la",
  "prc.refundPolicy": "Política de reembolsos",
  "prc.testMode": "Modo de prueba: usa la tarjeta 4242 4242 4242 4242, cualquier fecha futura y CVC.",
  "prc.sp1": "Todos los precios en dólares estadounidenses. Según tu país puede añadirse IVA o impuestos en el pago: verás el total exacto antes de pagar.",
  "prc.sp4pre": "¿Dudas? Cada pago de suscripción está cubierto por nuestra",
  "prc.sp4link": "garantía de devolución de 14 días",
  "prc.sp4post": "Los compradores nunca pagan por usar LytePress.",
  "prc.bizOnly": "Solo cuentas de negocio",
  "prc.bizOnlyMsg": "Los planes de pago son para negocios que publican ofertas.",
  "prc.checkoutFail": "No se pudo iniciar el pago",
  "prc.tryAgain": "Inténtalo de nuevo.",
  "prc.renewOff": "Renovación automática desactivada",
  "prc.renewOn": "Renovación automática activada",
  "prc.subFail": "No se pudo actualizar la suscripción",
  "ck.title": "Usamos cookies",
  "ck.body": "Usamos cookies esenciales para que LytePress funcione y otras opcionales para mejorar tu experiencia. Consulta nuestra",
  "ck.privacy": "Política de privacidad",
  "ck.acceptAll": "Aceptar todas",
  "ck.essential": "Solo esenciales",
  "ck.dismiss": "Cerrar",
  "undo.label": "Deshacer",
  "undo.done": "Restaurado",
  "undo.failed": "No se pudo deshacer, inténtalo de nuevo",
  "follows.unfollow": "Dejar de seguir",
  "follow.follow": "Seguir",
  "follow.following": "Siguiendo",
  "follow.now": "Siguiendo a {name}",
  "follow.nowMsg": "Te avisaremos cuando publique una nueva oferta.",
  "follow.stopped": "Dejaste de seguir a {name}",
  "follow.signInTitle": "Inicia sesión para seguir",
  "follow.signInMsg": "Crea una cuenta gratis de comprador para recibir avisos de ofertas.",
  "acc.shopperAccount": "Cuenta de comprador",
  "acc.verifiedSavingsThisMonth": "Ahorros verificados este mes",
  "acc.redeemADealCode": "Canjea un código de oferta en la tienda para comenzar a acumular ahorros verificados.",
  "acc.topSaverEveryBadge": "¡Mejor ahorrador — cada insignia desbloqueada!",
  "acc.recentRedemptions": "Canjes recientes",
  "acc.showPricesInMy": "Mostrar precios en mi moneda",
  "acc.dealsShowAnApproximate": "Las ofertas muestran un precio aproximado en esta moneda en toda la app.",
  "acc.showPricesAsIs": "Mostrar precios tal como están",
  "acc.emailPreferences": "Preferencias de correo electrónico",
  "acc.newDealAlerts": "Alertas de nuevas ofertas",
  "acc.emailMeWhenA": "Envíame un correo cuando un negocio que sigo publique una nueva oferta.",
  "acc.accountSecurityEmailsReceipts": "Los correos de cuenta y seguridad (recibos, restablecimientos de contraseña) siempre se envían.",
  "acc.myRedemptionCodes": "Mis códigos de canje",
  "acc.businessesYouFollow": "Negocios que sigues",
  "acc.youReNotFollowing": "No estás siguiendo ningún negocio aún. Sigue a un negocio para recibir notificaciones cuando publique una oferta.",
  "acc.browseBusinesses": "Explorar negocios",
  "acc.postADeal": "Publicar una oferta",
  "acc.redeemACustomerS": "Canjear el código de un cliente",
  "acc.whenAShopperShows": "Cuando un comprador muestre su código o QR en la caja, escanéalo o escríbelo aquí para confirmar y aplicar su descuento.",
  "acc.pointTheCameraAt": "Apunta la cámara al código QR del comprador.",
  "acc.dealsAlsoShowAn": "Las ofertas también muestran un precio aproximado en esta moneda en toda la app.",
  "acc.recommendedLogo": "Recomendado: logo",
  "acc.noCoverPhotoYet": "Sin foto de portada aún",
  "acc.contactInfo": "Información de contacto",
  "acc.showContactInfoOn": "Mostrar información de contacto en mi perfil público",
  "acc.addAnotherNumber": "Agregar otro número",
  "acc.saveContactInfo": "Guardar información de contacto",
  "acc.upgradeForMore": "Mejorar para más",
  "acc.myDeals": "Mis ofertas",
  "acc.featureNudgeTitle": "Sé el #1 en tu categoría",
  "acc.featureNudgeBody": "Coloca una de tus ofertas en la parte superior de nuestra página de inicio para los compradores de tu país — solo $10 por 24 horas.",
  "acc.featureNudgeCta": "Destacar una oferta",
  "acc.bookingsTitle": "Reservas destacadas próximas",
  "acc.bookingCancel": "Cancelar",
  "acc.bookingLive": "En vivo ahora",
  "acc.bookingCancelled": "Reserva cancelada",
  "acc.bookingRefunded": "Cancelada — reembolsada a tu tarjeta",
  "acc.bookingCancelFailed": "No se pudo cancelar la reserva",
  "acc.youHavenTPosted": "No has publicado ninguna oferta aún.",
  "acc.getListedTitle": "Aún no estás en el listado",
  "acc.getListedBody": "Los nuevos negocios solo aparecen en LytePress cuando publican una oferta activa. Publica tu primera oferta para aparecer en el listado y empezar a llegar a compradores cerca de ti.",
  "acc.postYourFirstDeal": "Publica tu primera oferta",
  "acc.pendingReview": "Pendiente de revisión",
  "acc.undoGrabReleaseThis": "Deshacer captura — liberar este código",
  "acc.enterCodeEG": "Ingresa el código p.ej. 7K9M2Q",
  "acc.labelEGPort": "Etiqueta (p.ej. sucursal de Puerto España)",
  "acc.removeNumber": "Eliminar número",
  "acc.shareOfViewersWho": "Porcentaje de espectadores que reclamaron esta oferta",
  "acc.duplicateThisDealAnd": "Duplicar esta oferta y editar antes de relanzar",
  "acc.couldNotUpdatePreferences": "No se pudo actualizar las preferencias",
  "acc.grabUndone": "Captura deshecha",
  "acc.couldnTUndo": "No se pudo deshacer",
  "acc.codeRedeemed": "Código canjeado ✓",
  "acc.couldnTRedeem": "No se pudo canjear",
  "acc.cameraUnavailable": "Cámara no disponible",
  "acc.allowCameraAccessOr": "Permitir acceso a la cámara, o escribe el código en su lugar.",
  "acc.saveMoreWasteLess": "Ahorra más. Desperdicia menos. — ¡sigue capturando ofertas!",
  "acc.contactInfoSaved": "Información de contacto guardada",
  "acc.couldNotSave": "No se pudo guardar",
  "acc.pleaseTryAgain": "Por favor, inténtalo de nuevo.",
  "acc.uploadFailed": "La carga falló",
  "acc.dealRemoved": "Oferta eliminada",
  "acc.couldNotRemove": "No se pudo eliminar",
  "acc.boostedForDays": "Impulsado por 7 días",
  "acc.couldNotStartCheckout": "No se pudo iniciar el pago",
  "acc.copyCreated": "Copia creada",
  "acc.couldNotDuplicate": "No se pudo duplicar",
  "tfa.twoFactorAuthentication": "Autenticación de dos factores",
  "tfa.addAnExtraLayer": "Agrega una capa extra de seguridad usando una app de autenticación (Google Authenticator, Authy, 1Password).",
  "tfa.disableFa": "Desactivar 2FA",
  "tfa.trustedDevices": "Dispositivos de confianza",
  "tfa.revokeAllRequireFa": "Revocar todo / requerir 2FA en todas partes",
  "tfa.noTrustedDevicesWhen": "No hay dispositivos de confianza. Al iniciar sesión, marca “Confiar en este dispositivo por 30 días” para omitir el aviso de 2FA aquí.",
  "tfa.eachCodeWorksOnce": "Cada código funciona una vez si pierdes tu autenticador. Almacénalos en un lugar seguro — no se mostrarán de nuevo.",
  "tfa.copyAllCodes": "Copiar todos los códigos",
  "tfa.iVeSavedThem": "Los he guardado",
  "tfa.confirmYourPasswordAnd": "Confirma tu contraseña y un código de autenticador actual para desactivar 2FA.",
  "tfa.yourPassword": "Tu contraseña",
  "tfa.digitCode": "Código de 6 dígitos",
  "tfa.deviceRevoked": "Dispositivo revocado",
  "tfa.thatDeviceWillNeed": "Ese dispositivo necesitará un código 2FA la próxima vez.",
  "tfa.couldNotRevokeDevice": "No se pudo revocar el dispositivo",
  "tfa.allTrustedDevicesRemoved": "Todos los dispositivos de confianza eliminados",
  "tfa.faWillBeRequired": "Se requerirá 2FA en cada dispositivo.",
  "tfa.couldNotRevokeDevices": "No se pudieron revocar los dispositivos",
  "tfa.couldNotStartFa": "No se pudo iniciar la configuración de 2FA",
  "tfa.pleaseTryAgain": "Por favor, inténtalo de nuevo.",
  "tfa.twoFactorAuthenticationEnabled": "Autenticación de dos factores habilitada ✓",
  "tfa.saveYourRecoveryCodes": "Guarda tus códigos de recuperación en un lugar seguro.",
  "tfa.couldnTVerifyCode": "No se pudo verificar el código",
  "tfa.twoFactorAuthenticationDisabled": "Autenticación de dos factores desactivada",
  "tfa.youCanReEnable": "Puedes volver a activarlo en cualquier momento.",
  "tfa.couldNotDisableFa": "No se pudo desactivar 2FA",
  "trips.savedTrips": "Viajes guardados",
  "trips.saveADestinationAnd": "Guarda un destino y recibe alertas de ofertas antes de llegar.",
  "trips.addTrip": "Agregar viaje",
  "trips.pickAPopularCity": "Elige una ciudad popular…",
  "trips.departureOptional": "Salida (opcional)",
  "trips.noTripsYetSave": "No hay viajes aún — guarda uno para recibir alertas de ofertas antes de aterrizar.",
  "trips.orSearchAnyCity": "…o busca cualquier ciudad, hotel o lugar de interés",
  "trips.searchPlace": "Buscar lugar",
  "trips.deleteTrip": "Eliminar viaje",
  "trips.placeNotFound": "Lugar no encontrado",
  "trips.tryACityHotel": "Prueba una ciudad, hotel o lugar de interés.",
  "trips.addADestinationAnd": "Agrega un destino y una fecha de inicio",
  "trips.tripSavedUUfe": "Viaje guardado \\u2708\\ufe0f",
  "trips.couldnTSaveTrip": "No se pudo guardar el viaje",
  "hrs.openingHours": "Horarios de apertura",
  "hrs.setOnceHereEvery": "Configura una vez aquí — cada oferta que publiques usará estos horarios para mostrar a los compradores cuándo estás abierto.",
  "hrs.timeZone": "Zona horaria",
  "hrs.copyMondayToAll": "Copiar lunes a todos los días",
  "hrs.holidayVacationMode": "Modo vacaciones / festivo",
  "hrs.showsYourBusinessAs": "Muestra tu negocio como “Temporalmente cerrado” en todas partes. Tus ofertas permanecen visibles.",
  "hrs.reopenDateOptional": "Fecha de reapertura (opcional)",
  "hrs.messageOptional": "Mensaje (opcional)",
  "hrs.eGBackOn": "p. ej. Volver el 5 de enero — ¡felices fiestas!",
  "hrs.mondayCopiedToEvery": "Lunes copiado a cada día",
  "hrs.tweakAnyDayThat": "Ajusta cualquier día que sea diferente, luego guarda.",
  "hrs.hoursSaved": "Horas guardadas",
  "hrs.yourOpeningHoursNow": "Tus horas de apertura ahora se aplican a todas tus ofertas.",
  "hrs.couldNotSave": "No se pudo guardar",
  "hrs.pleaseTryAgain": "Por favor, inténtalo de nuevo.",
  "br.businessLocations": "Ubicaciones de negocios",
  "br.defaultCurrency": "Moneda predeterminada",
  "br.yourDefaultCurrencyIs": "Tu moneda predeterminada está bloqueada.",
  "br.itSFixedTo": "Está fijada a",
  "br.becauseYouAlreadyHave": "porque ya tienes ofertas activas — esto mantiene tus precios y redenciones pasadas consistentes. Contacta al soporte si realmente necesitas cambiarlo.",
  "br.usedAsTheDefault": "Usada como la moneda de precio predeterminada para nuevas ofertas. Aviso: esto se bloquea una vez que publicas tu primera oferta.",
  "br.weReMultinationalSet": "Somos multinacionales — establece una moneda por sucursal",
  "br.pinEveryBranchLocation": "Fija cada sucursal/ubicación donde operas. Cuando publiques una oferta, estas se usarán automáticamente como las ubicaciones de la oferta — aún puedes cambiarlas por oferta.",
  "br.locationsSaved": "Ubicaciones guardadas",
  "br.newDealsWillDefault": "Las nuevas ofertas se establecerán por defecto en estas ubicaciones y moneda.",
  "br.couldNotSave": "No se pudo guardar",
  "br.pleaseTryAgain": "Por favor, inténtalo de nuevo.",
  "tb.recentSearches": "Búsquedas recientes",
  "tb.didYouMean": "¿Quisiste decir",
  "tb.noQuickMatchesPress": "No hay coincidencias rápidas — presiona Enter para buscar todo.",
  "tb.searchDeals": "Buscar ofertas",
  "tb.toggleAiAssistedSearch": "Alternar búsqueda asistida por IA",
  "tb.findDealsNearMe": "Encontrar ofertas cerca de mí",
  "tb.removeFromRecentSearches": "Eliminar de búsquedas recientes",
  "tb.showDealsEverywhere": "Mostrar ofertas en todas partes",
  "tb.searchThisPlace": "Buscar este lugar",
  "tb.toggleTheme": "Alternar tema",
  "tb.locationSet": "Ubicación establecida",
  "tb.placeNotFound": "Lugar no encontrado",
  "tb.tryADifferentCity": "Intenta con una ciudad, pueblo o nombre de lugar diferente.",
  "tb.showingDealsEverywhere": "Mostrando ofertas en todas partes",
  "tb.browsingDealsFromAll": "Navegando ofertas de todos los países.",
  "tb.notSupported": "No soportado",
  "tb.geolocationIsnTAvailable": "La geolocalización no está disponible en este navegador.",
  "tb.locationFound": "Ubicación encontrada",
  "tb.locationPermissionDenied": "Permiso de ubicación denegado",
  "tb.allowLocationForThis": "Permite la ubicación para este sitio en la configuración de la barra de direcciones de tu navegador, luego toca Cerca de mí nuevamente.",
  "tb.locationTimedOut": "Tiempo de espera de ubicación agotado",
  "tb.couldnTGetA": "No se pudo obtener una ubicación a tiempo. Muévete a un lugar abierto o inténtalo de nuevo — o elige una ciudad arriba.",
  "tb.locationUnavailable": "Ubicación no disponible",
  "tb.weCouldnTDetermine": "No pudimos determinar tu posición. Intenta de nuevo, o elige un país/ciudad arriba.",
  "an.couldNotLoadAnalytics": "No se pudieron cargar las analíticas.",
  "an.performanceOfYourDeals": "Rendimiento de tus ofertas y promociones.",
  "an.postADeal": "Publicar una oferta",
  "an.noDealsYetPost": "No hay ofertas aún — publica tu primera oferta para comenzar a ver análisis.",
  "an.yourAverageDiscountIs": "Tu descuento promedio es",
  "an.belowTheNearbyAverage": "por debajo del promedio cercano de",
  "an.forYourCategoryA": "para tu categoría. Un descuento un poco mayor suele generar más vistas y compartidos.",
  "an.bestTimeToPost": "Mejor momento para publicar",
  "an.newFollowersLastDays": "Nuevos seguidores (últimos 14 días)",
  "an.viewsOverTime": "Vistas a lo largo del tiempo",
  "an.lastDays": "Últimos 14 días",
  "an.noViewDataYet": "No hay datos de vistas aún — se acumularán a medida que los compradores abran tus ofertas.",
  "an.yourCompetition": "Tu competencia",
  "an.liveDeals": "Ofertas activas",
  "an.avgDiscount": "Descuento promedio",
  "an.tipClickARival": "Consejo: haz clic en un rival para comparar tus ofertas activas lado a lado.",
  "an.redemptionsByDeal": "Canjeos por oferta",
  "an.bestPerformer": "Mejor rendimiento",
  "an.redemptionsAreCustomersWho": "Los canjeos son clientes que mostraron su código de LytePress en la tienda — prueba de que la plataforma los envió a ti.",
  "an.redemptionsOverTime": "Canjeos a lo largo del tiempo",
  "an.dealLeaderboard": "Clasificación de ofertas",
  "an.byRedemptionRate": "por tasa de canjeo",
  "an.viewsByCategory": "Vistas por categoría",
  "an.noDataYet": "No hay datos aún.",
  "an.topPerformingDeals": "Ofertas de mejor rendimiento",
  "an.sharesOverTime": "Compartidos a lo largo del tiempo",
  "an.noSharesYetThis": "No hay compartidos aún — esta línea crece a medida que los compradores comparten tus ofertas con amigos.",
  "an.mostSharedDeals": "Ofertas más compartidas",
  "an.noSharesYetThis2": "No hay compartidos aún — esto se llena a medida que los compradores usan el botón de compartir para difundir tus ofertas a amigos.",
  "an.loadingComparison": "Cargando comparación…",
  "an.noLiveDeals": "No hay ofertas activas.",
  "an.matchOrBeat": "Igualar o superar",
  "an.totalViews": "Total de vistas",
  "an.totalDeals": "Total de ofertas",
  "an.activeDeals": "Ofertas activas",
  "an.avgDiscount2": "Descuento promedio",
  "an.totalShares": "Total de compartidos",
  "an.inStoreRedemptions": "Canjeos en tienda",
  "an.nearExpiry": "Cerca de expirar",
  "reg.registerYourBusiness": "Registra tu negocio",
  "reg.startPostingDealsTo": "Comienza a publicar ofertas para tu comunidad.",
  "reg.whereIsYourBusiness": "¿Dónde está tu negocio?",
  "reg.yourMainLocationYou": "Tu ubicación principal — puedes agregar más sucursales después de registrarte en Mi Cuenta → Ubicaciones.",
  "reg.dealCurrency": "Moneda de la oferta",
  "reg.byCreatingAnAccount": "Al crear una cuenta aceptas nuestros",
  "reg.termsOfUse": "Términos de Uso",
  "reg.privacyPolicy": "Política de Privacidad",
  "reg.alreadyRegistered": "¿Ya registrado?",
  "reg.logIn": "Iniciar sesión",
  "reg.yourName": "Tu nombre",
  "reg.businessName": "Nombre del negocio",
  "reg.pickYourCity": "Elige tu ciudad",
  "reg.startTypingYourCity": "Comienza a escribir tu ciudad y elígela de la lista.",
  "reg.accountCreated": "¡Cuenta creada!",
  "reg.registrationFailed": "Registro fallido",
  "rst.setANewPassword": "Establece una nueva contraseña",
  "rst.chooseAStrongPassword": "Elige una contraseña fuerte que no uses en otros lugares.",
  "rst.forgotPassword": "Olvidé mi contraseña",
  "rst.newPassword": "Nueva contraseña",
  "rst.confirmNewPassword": "Confirma la nueva contraseña",
  "rst.passwordTooShort": "Contraseña demasiado corta",
  "rst.useAtLeastCharacters": "Usa al menos 8 caracteres.",
  "rst.passwordsDonTMatch": "Las contraseñas no coinciden",
  "rst.passwordReset": "Contraseña restablecida ✓",
  "rst.youCanNowLog": "Ahora puedes iniciar sesión con tu nueva contraseña.",
  "rst.couldnTResetPassword": "No se pudo restablecer la contraseña",
  "fgt.checkYourEmail": "Revisa tu correo electrónico",
  "fgt.ifThatEmailIs": "Si ese correo electrónico está registrado, hemos enviado un enlace para restablecer tu contraseña. Expira en 45 minutos.",
  "fgt.forgotYourPassword": "¿Olvidaste tu contraseña?",
  "fgt.enterYourEmailAnd": "Ingresa tu correo electrónico y te enviaremos un enlace de restablecimiento.",
  "fgt.rememberedIt": "¿Lo recordaste?",
  "fgt.logIn": "Iniciar sesión",
  "ct.contactUs": "Contáctanos",
  "ct.questionsPartnershipsOrFeedback": "Preguntas, asociaciones o comentarios — nos encantaría saber de ti.",
  "ct.sendMessage": "Enviar mensaje",
  "ct.yourName": "Tu nombre",
  "ct.emailAddress": "Correo electrónico",
  "ct.yourMessage": "Tu mensaje",
  "ct.messageSent": "Mensaje enviado",
  "ct.thanksForReachingOut": "Gracias por contactarnos — normalmente respondemos en un día laborable.",
  "st.ourStory": "Nuestra historia",
  "st.saveMoreWasteLess": "Ahorra más. Desperdicia menos. Apoya lo local.",
  "st.moreThanADirectory": "Más que un directorio. Más que un sitio de ofertas.",
  "st.lookingAheadOurGoal": "Mirando hacia el futuro, nuestro objetivo es expandirnos al mercado internacional — para que los viajeros y turistas puedan abrir LytePress en cualquier parte del mundo y encontrar instantáneamente las mejores ofertas cerca de ellos, donde sea que los lleve su viaje.",
  "st.thinkOfItThis": "Piénsalo de esta manera — sitios como Expedia te ayudan a planear el viaje; LytePress te ayuda a ahorrar una vez que estás allí, con las mejores ofertas locales cerca de ti.",
  "st.whetherYouReA": "Ya seas un negocio que busca alcanzar nuevos clientes o un consumidor que quiere descubrir lo que sucede a tu alrededor, LytePress está aquí para ayudarte a ahorrar más, desperdiciar menos y apoyar lo local.",
  "st.exploreDeals": "Explora ofertas",
  "st.contactUs": "Contáctanos",
  "st.supportLocal": "Apoya lo local",
  "st.wasteLess": "Desperdicia menos",
  "st.communityFirst": "Comunidad primero",
  "lg.lytepressOnlyEverCharges": "LytePress solo cobra",
  "lg.onASingleDeal": "por una sola oferta, y un",
  "lg.shoppersNeverPayUs": "Los compradores nunca nos pagan por una oferta. Cada oferta es vendida y canjeada por el negocio que la publicó, así que cualquier cosa relacionada con los bienes o servicios — el precio cobrado en la tienda, calidad, disponibilidad, cambios o reembolsos — es entre el comprador y ese negocio bajo su propia política y la ley de consumo local.",
  "lg.ifABusinessRefuses": "Si un negocio se niega a honrar una oferta que publicó, infórmanos usando la opción de reporte en la oferta o a través de la página de contacto. Podemos eliminar la oferta y el negocio de LytePress, pero no podemos reembolsar una compra por la que no recibimos pago.",
  "lg.ofThePaymentAnd": "del pago y reembolsaremos ese pago en su totalidad. No se necesita razón, y se aplica tanto a planes mensuales como anuales.",
  "lg.cancelAndWeRefund": "cancela y reembolsamos en su totalidad.",
  "lg.thePlacementHasAlready": "la colocación ya ha sido entregada a los compradores, por lo que no es reembolsable. Aún puedes eliminar o editar la oferta, pero el gasto permanece utilizado.",
  "lg.ifAPlacementFailed": "Si una colocación falló debido a un error de nuestra parte — nunca se publicó, o la oferta fue oculta por nosotros durante el período — la reembolsamos en su totalidad o la volvemos a publicar, lo que prefieras.",
  "lg.emailUsFromThe": "Envíanos un correo desde la dirección de tu cuenta de LytePress, o usa la página de Contacto, con el nombre de tu negocio y la fecha del cargo. Respondemos en un plazo de 3 días hábiles. Los reembolsos aprobados regresan al método de pago original y pueden tardar de 5 a 10 días hábiles en aparecer, dependiendo de tu banco.",
  "lg.refundsIncludeAnyTax": "Los reembolsos incluyen cualquier impuesto que cobramos en el pago original. Reembolsamos en la moneda en la que fuiste facturado — si tu banco convirtió el monto, la cifra que llegue puede diferir ligeramente debido a tasas de cambio o comisiones bancarias que no controlamos.\n\nNuestros precios se fijan en dólares estadounidenses (USD). En el momento del pago, nuestro proveedor de pagos puede mostrar y cobrar el importe en tu moneda local, convertido a su propio tipo de cambio. Cualquier transacción también puede estar sujeta a cargos por conversión de moneda, comisiones bancarias, comisiones del emisor de la tarjeta u otros cargos aplicados por tu banco o proveedor de tarjeta. Estos se suman al precio mostrado, están fuera de nuestro control y son tu responsabilidad.",
  "lg.pleaseTalkToUs": "Por favor, háblanos antes de presentar una disputa con tu banco — casi siempre podemos resolverlo más rápido. Las cuentas con un contracargo no resuelto pueden tener funciones pagadas pausadas hasta que se resuelva.",
  "lg.youCanStopUsing": "Puedes dejar de usar LytePress cuando quieras y eliminar tus ofertas de Mi Cuenta. Cancelar una cuenta no reembolsa automáticamente un pago ya realizado — usa las reglas anteriores.",
  "lg.billingQuestionsReachUs": "¿Preguntas sobre facturación? Contáctanos a través de la página de Contacto.",
  "lg.lytepressHelpsShoppersDiscover": "LytePress ayuda a los compradores a descubrir ofertas locales y globales y permite a los negocios publicar ofertas. Debes poder formar un contrato vinculante para usar el servicio, y aceptas usarlo de manera legal.",
  "lg.youAreResponsibleFor": "Eres responsable de mantener segura tu información de inicio de sesión y cualquier código de autenticación de dos factores. Las cuentas de negocios son responsables de la precisión de las ofertas, precios, sucursales y detalles de contacto que publican.",
  "lg.dealsAreOfferedBy": "Las ofertas son ofrecidas por los negocios que las publican, no por LytePress. La disponibilidad, precios y redención en tienda son responsabilidad de ese negocio. Los códigos de redención son para un solo uso a menos que se indique lo contrario.",
  "lg.refundPolicy": "Política de Reembolso",
  "lg.donTPostUnlawful": "No publiques contenido ilegal, engañoso o que infrinja derechos, intentes interrumpir el servicio, o maluses los datos de otros usuarios.",
  "lg.weMayUpdateThese": "Podemos actualizar estos términos o el servicio, y podemos suspender cuentas que los violen. El uso continuado después de los cambios significa que aceptas los términos actualizados.",
  "lg.questionsAboutTheseTerms": "¿Preguntas sobre estos términos? Contáctanos a través de la página de Contacto.",
  "lg.toRunTheService": "Para operar el servicio — mostrándote ofertas relevantes cerca de ti, enviando notificaciones de ofertas a las que te suscribas, procesando redenciones y pagos, y manteniendo tu cuenta segura.",
  "lg.ifYouUseNear": "Si usas \"Cerca de mí\" o Modo Turista, usamos la ubicación que proporcionas (o la ubicación de tu dispositivo, con permiso) solo para encontrar ofertas cercanas. Siempre puedes elegir una ubicación manualmente en su lugar.",
  "lg.ipAndGeo": "Para mejorar tu experiencia, usamos tu dirección IP para estimar tu ubicación aproximada (normalmente tu país), de modo que el mapa, las ofertas y el idioma de la interfaz se ajusten por defecto a donde estás, en lugar de empezar siempre en otro lugar. Es una aproximación y puede ser inexacta; puedes cambiar tu país, ciudad e idioma en cualquier momento, y esa elección prevalece sobre la estimación. La ubicación GPS precisa solo se usa si tocas \"Cerca de mí\" y concedes permiso. Las estimaciones de ubicación por IP se guardan brevemente, solo para agilizar las visitas recurrentes, y caducan automáticamente.",
  "lg.analyticsTitle": "Analítica",
  "lg.analyticsBody": "Usamos software de analítica de terceros respetuoso con la privacidad (por ejemplo, Plausible Analytics) para entender cómo se usa el sitio, como qué páginas se visitan y qué funciones son populares. Esto puede implicar que un proveedor de analítica externo procese datos de uso anónimos y agregados en nuestro nombre. Estas herramientas no usan cookies y no te rastrean en otros sitios web ni crean un perfil personal tuyo. Podemos añadir, cambiar o eliminar proveedores de analítica con el tiempo.",
  "lg.notResponsibleForDeals": "LytePress es únicamente una plataforma de anuncios. Las ofertas, precios, productos, servicios y condiciones de canje son creados, ofrecidos y cumplidos enteramente por los negocios independientes que los publican; no son nuestras ofertas. No vendemos, suministramos, respaldamos ni garantizamos ninguna oferta, y no somos responsables de la disponibilidad, exactitud, calidad, seguridad o legalidad de lo que ofrece un negocio, ni de que un negocio rechace, cambie o no cumpla una oferta. Cualquier compra o canje es un contrato entre tú y ese negocio; cualquier disputa sobre una oferta es entre tú y ellos. Revisa los detalles de cada oferta y los términos del negocio antes de confiar en ella.",
  "lg.privacyQuestionsReachUs": "¿Preguntas sobre privacidad? Contáctanos a través de la página de Contacto.",
  "lg.whatLytepressChargesFor": "1. Por qué cobra LytePress",
  "lg.dealsAreNotSold": "2. Las ofertas no son vendidas por LytePress",
  "lg.boostsAndFeaturedPlacements": "4. Aumentos y colocaciones destacadas",
  "lg.howToRequestA": "5. Cómo solicitar un reembolso",
  "lg.taxesCurrencyAndFees": "6. Impuestos, moneda y tarifas",
  "lg.chargebacks": "7. Contracargos",
  "lg.cancellingYourAccount": "8. Cancelando tu cuenta",
  "lg.contact": "9. Contacto",
  "lg.usingLytepress": "1. Usando LytePress",
  "lg.accounts": "2. Cuentas",
  "lg.dealsRedemptions": "3. Ofertas y redenciones",
  "lg.payments": "4. Pagos",
  "lg.acceptableUse": "5. Uso aceptable",
  "lg.changesTermination": "6. Cambios y terminación",
  "dd.savedTo": "Guardado en",
  "dd.myDeals": "Mis Ofertas",
  "dd.save": "Guardar",
  "dd.saved": "Guardado",
  "dd.favourite": "Guardar oferta",
  "dd.backToDeals": "Volver a ofertas",
  "dd.showThisAtCheckout": "Mostrar esto al pagar",
  "dd.changedYourMindUndo": "¿Cambiastes de opinión? Deshacer selección",
  "bp.businessNotFound": "Negocio no encontrado.",
  "bp.browseBusinesses": "Explorar negocios",
  "bp.loading": "Cargando…",
  "bp.allBusinesses": "Todos los negocios",
  "bp.noLiveDealsRight": "No hay ofertas activas en este momento — sigue para recibir notificaciones cuando publiquen una.",
  "bp.verifiedBusiness": "Negocio verificado",
  "bp.businessLocation": "Ubicación del negocio",
  "bl.localGlobalMerchants": "Comerciantes locales y globales",
  "bl.discoverBusinesses": "Descubre negocios",
  "bl.followYourFavouriteShops": "Sigue tus tiendas favoritas y nunca te pierdas una oferta nueva.",
  "bl.noBusinessesMatchThese": "No hay negocios que coincidan con estos filtros.",
  "bl.viewProfile": "Ver perfil",
  "dsh.seePricesInYour": "Ver precios en tu moneda",
  "dsh.pickYourCurrencyAnd": "Elige tu moneda y cada oferta mostrará una estimación instantánea en el dinero que usas.",
  "dsh.chooseCurrency": "Elegir moneda…",
  "psx.confirmingYourPayment": "Confirmando tu pago…",
  "psx.thisOnlyTakesA": "Esto solo toma un momento.",
  "psx.paymentSuccessful": "¡Pago exitoso!",
  "psx.yourUpgradeIsNow": "Tu actualización ahora está activa. Gracias por apoyar a LytePress.",
  "psx.goToMyAccount": "Ir a Mi Cuenta",
  "psx.backToPremium": "Volver a Premium",
  "pcx.checkoutCancelled": "Pago cancelado",
  "pcx.noWorriesYouHave": "No te preocupes — no se te ha cobrado.",
  "pcx.backToPremium": "Volver a Premium",
  "nf.thisPageTookA": "Esta página tomó un desvío",
  "nf.thePageYouRe": "La página que buscas no existe o puede haber expirado. Vamos a llevarte de vuelta a lo bueno.",
  "nf.backHome": "Volver a casa",
  "nf.browseDeals": "Explorar ofertas",
  "nf.goBack": "Regresar",
  "cat.exploreByCategory": "Explorar por categoría",
  "cat.browseAll": "Explorar todo",
  "cat.grabThemFast": "Tómalo rápido",
  "md.undoGrab": "Deshacer selección",
  "bd.aiSearch": "Búsqueda AI",
  "bd.findingTheBestMatches": "Encontrando las mejores coincidencias…",
  "bd.nearMe": "Cerca de mí",
  "bd.openNow": "abierto ahora",
  "bd.nearMe2": "cerca de mí",
  "bd.noExactMatchesSearching": "No hay coincidencias exactas — buscando por significado…",
  "lm.googleMapsApiKey": "Clave de API de Google Maps no configurada.",
  "lm.loadingMap": "Cargando mapa...",
  "pdx.movePhotoLeft": "Mover foto a la izquierda",
  "pdx.movePhotoRight": "Mover foto a la derecha",
  "pdx.eGLyte": "p. ej. LYTE20",
  "pdx.couldNotLoadDeal": "No se pudo cargar la oferta",
  "pdx.pleaseTryAgain": "Por favor, inténtalo de nuevo.",
  "pdx.photosAdded": "Fotos añadidas",
  "ip.addLytepressToYour": "Añadir LytePress a tu pantalla de inicio",
  "ip.addToHomeScreen": "Añadir a la pantalla de inicio",
  "ip.fasterAccessToDeals": "Acceso más rápido a ofertas cerca de ti y tus códigos de canje — no se necesita tienda de aplicaciones.",
  "rev.verifiedReviews": "Reseñas verificadas",
  "rev.verifiedRedemption": "Canje verificado",
  "rev.redeemOneOfThis": "Canjea una de las ofertas de este negocio en la tienda para dejar una reseña verificada.",
  "rev.noReviewsYetBe": "No hay reseñas aún — sé el primero después de canjear una oferta.",
  "rev.shareHowTheDeal": "Comparte cómo fue la oferta (opcional)…",
  "rev.replyPubliclyToThis": "Responde públicamente a esta reseña…",
  "rev.pickAStarRating": "Elige una calificación de estrellas",
  "rev.tapStarsToRate": "Toca 1–5 estrellas para calificar este negocio.",
  "rev.yourVerifiedReviewIs": "Tu reseña verificada ya está activa.",
  "rev.couldnTPostReview": "No se pudo publicar la reseña",
  "rev.replyIsEmpty": "La respuesta está vacía",
  "rev.writeAShortReply": "Escribe primero una respuesta corta.",
  "rev.replyPosted": "Respuesta publicada",
  "rev.shoppersCanNowSee": "Los compradores ahora pueden ver tu respuesta.",
  "rev.couldnTPostReply": "No se pudo publicar la respuesta",
  "tm.touristMode": "Modo turista",
  "tm.localPrices": "Precios locales",
  "tm.noneYet": "ninguno aún",
  "tm.saveThisBase": "Guardar esta base",
  "tm.iMVisitingShow": "Estoy de visita — muestra las mejores ofertas cerca de mí",
  "tm.hotelLandmarkOrAddress": "Hotel, punto de referencia o dirección…",
  "tm.setBaseLocation": "Establecer ubicación base",
  "tm.exitTouristMode": "Salir del modo turista",
  "tm.removeBase": "Eliminar base",
  "tm.touristModeOn": "Modo turista activado ✈️",
  "tm.showingDealsNearYou": "Mostrando ofertas cerca de ti, con precios en tu moneda, con direcciones de un toque.",
  "tm.typeTheHotelLandmark": "Escribe el hotel, punto de referencia o área donde te alojas para ver ofertas cercanas.",
  "tm.baseUpdated": "Base actualizada 📍",
  "tm.placeNotFound": "Lugar no encontrado",
  "tm.tryAHotelName": "Prueba con un nombre de hotel, punto de referencia o dirección.",
  "rpt.reportThisDeal": "Reportar esta oferta",
  "rpt.tellUsWhatS": "Dinos qué está mal para que nuestro equipo pueda revisarlo.",
  "rpt.reportDeal": "Reportar oferta",
  "rpt.addAnyDetailsOptional": "Añadir detalles (opcional)",
  "rpt.spamOrMisleading": "Spam o engañoso",
  "rpt.wrongOrFakePrice": "Precio incorrecto o falso",
  "rpt.offensiveOrInappropriate": "Ofensivo o inapropiado",
  "rpt.expiredNoLongerAvailable": "Caducado / ya no disponible",
  "rpt.somethingElse": "Algo más",
  "rpt.signInToReport": "Inicia sesión para reportar",
  "rpt.pleaseLogInTo": "Por favor, inicia sesión para reportar una oferta.",
  "rpt.thanksForTheReport": "Gracias por el reporte",
  "rpt.ourTeamWillReview": "Nuestro equipo revisará esta oferta.",
  "rpt.couldNotSubmitReport": "No se pudo enviar el reporte",
  "dlp.mapUnavailableNoApi": "Mapa no disponible (sin clave API)",
  "dlp.loadingMap": "Cargando mapa…",
  "dlp.useBusinessDefaultCurrency": "Usar moneda predeterminada del negocio",
  "dlp.openingHoursOverrideOptional": "Horas de apertura opcionales",
  "dlp.placeNotFound": "Lugar no encontrado",
  "dlp.tryADifferentAddress": "Intenta con una dirección o nombre de lugar diferente.",
  "dlp.gpsUnavailable": "GPS no disponible",
  "dlp.searchAnAddressInstead": "Busca una dirección en su lugar.",
  "dlp.pinnedYourLocation": "Ubicación fijada",
  "dlp.couldnTGetLocation": "No se pudo obtener la ubicación",
  "dlp.allowLocationAccessOr": "Permite el acceso a la ubicación o busca una dirección.",
  "shb.shareDeal": "Compartir oferta",
  "shb.shareThisDeal": "Comparte esta oferta",
  "shb.linkCopied": "Enlace copiado",
  "shb.shareItWithFriends": "¡Compártelo con amigos!",
  "shb.couldnTCopyLink": "No se pudo copiar el enlace",
  "shs.shareMySavings": "Comparte mis ahorros",
  "shs.copied": "¡Copiado!",
  "shs.pasteItAnywhereTo": "Pégalo en cualquier lugar para invitar amigos.",
  "shs.couldnTCopy": "No se pudo copiar",
  "shs.myLytepressSavings": "Mis ahorros en LytePress",
  "rgc.monthlyRedemptionGoal": "Meta de redención mensual",
  "rgc.redemptionsMonth": "redenciones / mes",
  "rgc.setAMonthlyTarget": "Establece una meta mensual para rastrear tus redenciones y mantener al equipo motivado.",
  "rgc.goalReachedNicelyDone": "Meta alcanzada — ¡bien hecho!",
  "obc.dismissChecklist": "Descartar lista de verificación",
  "obc.profileLinkCopied": "Enlace de perfil copiado",
  "obc.pasteItOnWhatsapp": "Pégalo en el estado de WhatsApp, biografía de Instagram o en la vitrina de tu tienda.",
  "obc.hereSYourLink": "Aquí está tu enlace",
  "obc.addYourLogo": "Agrega tu logo",
  "obc.addAContactNumber": "Agrega un número de contacto",
  "obc.pinYourLocation": "Fija tu ubicación",
  "obc.postYourFirstDeal": "Publica tu primera oferta",
  "obc.shareYourProfileLink": "Comparte el enlace de tu perfil",
  "rr.alertsEnabled": "Alertas habilitadas",
  "rr.youLlBeNotified": "Serás notificado de nuevas ofertas (demo).",
  "pc.popularDestinations": "Destinos populares",
  "sb.logOut": "Cerrar sesión",
  "st.para1": "Creemos que descubrir grandes negocios locales debería ser fácil, gratificante y accesible para todos.",
  "st.para2": "Cada día, los negocios lanzan nuevos productos, crean ofertas especiales, organizan eventos, realizan promociones y ofrecen servicios valiosos de los que muchos clientes nunca se enteran. Al mismo tiempo, los consumidores están constantemente buscando maneras de ahorrar dinero, descubrir nuevas experiencias y conectarse con sus comunidades.",
  "st.para3": "Creamos LytePress para unir esos dos mundos.",
  "st.para4": "LytePress es una plataforma donde los negocios locales pueden mostrar promociones, eventos, sorteos, ofertas especiales y oportunidades, mientras que los consumidores pueden descubrir nuevas formas de ahorrar, comprar, comer, explorar y relacionarse con los negocios a su alrededor.",
  "st.para5": "También estamos comprometidos a reducir el desperdicio innecesario ayudando a los negocios a promover productos en exceso y cerca de su fecha de caducidad que aún tienen valor, creando beneficios tanto para los negocios como para los consumidores.",
  "st.valSupportLocal": "Conectando comunidades con los negocios a su alrededor.",
  "st.valWasteLess": "Promoviendo productos en exceso y cerca de su fecha de caducidad que aún tienen valor.",
  "st.valCommunity": "Una comunidad en crecimiento que recompensa el gasto inteligente y el emprendimiento.",
  "st.sustainable": "Sostenible",
  "an.nViews": "{n} vistas",
  "an.nViewsNDeals": "{v} vistas · {d} ofertas",
  "an.nSharesNViews": "{s} compartidos · {v} vistas",
  "dc.seeAllIn": "Ver todas las ofertas de {name}",
  "acc.nOfMLiveDeals": "{n} / {m} ofertas activas",
  "cat.nLiveDeals": "{n} ofertas activas",
  "cat.nCategories": "{n} categorías",
  "bl.allCategories": "Todas las categorías",
  "reg.and": "y",
  "acc.planLabelPlan": "plan {plan}",
  "acc.showInCurrency": "Mostrar en {code} — {label}",
  "home.slide1a": "Grandes Ofertas.",
  "home.slide1b": "Menos Desperdicio.",
  "home.slide1sub": "Descubre ofertas de negocios locales y rescata productos próximos a vencer antes de que se acaben.",
  "home.slide1badge": "Ahorra hasta 70%",
  "home.slide2a": "Compra Local.",
  "home.slide2b": "Ahorra Más.",
  "home.slide2sub": "Apoya a los negocios locales y encuentra las ofertas que tienen cerca de ti.",
  "home.slide2badge": "Hasta 60% de descuento",
  "home.slide3a": "Todas las Ofertas.",
  "home.slide3b": "En un Solo Lugar.",
  "home.slide3sub": "Todas las categorías en un solo lugar, para que nunca te pierdas una oferta local.",
  "home.slide3badge": "Descuento Flash del 50%",
  "home.vp1t": "Ahorra Dinero",
  "home.vp1x": "Grandes descuentos en tus artículos favoritos",
  "home.vp2t": "Reduce Desperdicio",
  "home.vp2x": "Ayuda a los negocios a reducir el desperdicio de alimentos y productos",
  "home.vp3t": "Apoya lo Local",
  "home.vp3x": "Empodera a los negocios locales en tu comunidad",
  "home.slideN": "Diapositiva {n}",
  "vf.title": "Verificación de negocio",
  "vf.riskyNote": "Estas categorías necesitan verificación antes de que puedas publicar en ellas: {list}",
  "vf.upload": "Subir documento",
  "vf.sent": "Documentos enviados",
  "vf.sentMsg": "Los revisaremos y te enviaremos un correo — generalmente dentro de un día.",
  "vf.failed": "No se pudo enviar eso",
  "vf.pendingMsg": "Estamos revisando tus documentos — te enviaremos un correo cuando esté listo.",
  "vf.verifiedMsg": "Tu negocio está verificado. La insignia azul aparece en tu perfil y en el directorio.",
  "vf.rejected": "No pudimos verificar tu negocio con esos documentos. Intenta con fotos más claras.",
  "vf.independent": "Vendedor independiente",
  "vf.verifiedTag": "Negocio verificado",
  "bl.allCountries": "Todos los países",
  "bl.nDeals": "{n} ofertas",
  "sidebar.plusActive": "Elite activo",
  "sidebar.forLife": "Para siempre",
  "cat.Bakery": "Panadería",
  "cat.Electronics": "Electrónica",
  "cat.Food & Beverages": "Comida y Bebidas",
  "cat.Groceries": "Abarrotes",
  "cat.Health & Beauty": "Salud y Belleza",
  "cat.Restaurants": "Restaurantes",
  "bl.nBusinesses": "{n} negocios",
  "cat.subScoped": "Explora ofertas seleccionadas en cada categoría en {scope}. Toca un cuadro para sumergirte.",
  "cat.subGlobal": "Explora ofertas seleccionadas en cada categoría de todo el mundo. Toca un cuadro para sumergirte.",
  "cat.nLiveRightNow": "{n} en vivo ahora mismo",
  "browse.verifiedOnly": "Solo verificados",
  "bl.verifiedOnly": "Solo verificados",
  "map.verifiedOnly": "Solo verificados",
  "browse.emptyVerified": "No hay negocios verificados con ofertas activas aquí todavía — intenta desactivar “Solo verificados”.",
  "trust.whatsThis": "¿Qué es esto?",
  "trust.title": "Lo que significa “verificado”",
  "trust.verifiedTitle": "Negocio verificado",
  "trust.independentTitle": "Vendedor independiente",
  "trust.limitsTitle": "Lo que no promete",
  "trust.limitsBody": "La insignia se refiere a quiénes son, no a una garantía del producto, el servicio o el precio. Siempre revisa los términos de la oferta antes de comprar.",
  "trust.reportTitle": "¿Algo mal?",
  "trust.reportBody": "Toca Reportar en cualquier oferta. Dos reportes la señalan para nuestro equipo, y eliminamos ofertas que engañan a los compradores.",
  "trust.footer": "Las categorías sensibles — salud, eventos, tecnología y automotriz — solo pueden ser publicadas por negocios verificados.",
  "apl.title": "Apelar una decisión",
  "apl.subtitle": "¿Algo que hicimos mal? Responde una vez y lo resolveremos aquí.",
  "apl.appeal": "Apelar",
  "apl.send": "Enviar apelación",
  "apl.cancel": "Cancelar",
  "apl.reason": "Nuestra razón",
  "apl.placeholder": "Cuéntanos qué pasó — cuanto más específico, más rápido podremos solucionarlo.",
  "apl.onceNote": "Puedes apelar cada decisión una vez. Respondemos por correo electrónico.",
  "apl.sent": "Apelación enviada",
  "apl.sentMsg": "Lo revisaremos y te enviaremos un correo.",
  "apl.failed": "No se pudo enviar eso",
  "apl.pending": "Estamos revisando tu apelación",
  "apl.granted": "Resuelto — estamos de acuerdo contigo",
  "apl.declined": "Mantenemos nuestra decisión",
  "apl.deal": "Oferta eliminada: {title}",
  "apl.watch": "Tus ofertas son revisadas antes de publicarse",
  "apl.watchDetail": "Esto sucede después de que se eliminan dos ofertas.",
  "apl.suspension": "Tu cuenta está suspendida",
  "apl.verification": "La verificación no fue aprobada",
  "qa.appeal_short": "Por favor, cuéntanos qué pasó en al menos 20 caracteres — nos ayuda a resolver esto rápidamente.",
  "qa.appeal_once": "Ya has apelado esto una vez — te responderemos por correo electrónico.",
  "acc.activeDeals": "Ofertas activas",
  "acc.totalViews": "Vistas totales",
  "acc.totalClaims": "Reclamaciones totales",
  "acc.nClaims": "{n} reclamaciones",
  "acc.nConversion": "{n} conversiones",
  "acc.goesLive": "Se activa {when}",
  "adn.title": "Complementos: paga solo por lo que necesitas",
  "adn.sub": "Los planes cubren las funciones que no nos cuestan nada. Estos son limitados o requieren trabajo real, así que se venden aparte: pago único, sin suscripción.",
  "adn.slotsTitle": "5 espacios extra para ofertas",
  "adn.slotsBody": "Cinco espacios más para ofertas activas además de tu plan, por 30 días. Cómpralos otra vez cuando quieras: se acumulan.",
  "adn.slotsCta": "Añadir 5 espacios — {price}",
  "adn.slotsActive": "{n} espacios extra activos",
  "adn.boostTitle": "Impulsa una oferta",
  "adn.boostCta": "Impulsar desde Mi cuenta",
  "adn.verifyTitle": "Verificación prioritaria",
  "adn.verifyBody": "Tus documentos de registro pasan al frente de la fila de revisión en vez de esperar su turno.",
  "adn.verifyCta": "Revisión prioritaria — {price}",
  "adn.verifyDone": "Tienes revisión prioritaria: veremos tus documentos primero.",
  "adn.verifiedAlready": "Tu negocio ya está verificado.",
  "adn.oneOff": "Pagos únicos, no suscripciones",
  "srv.title": "¿Por qué pagarías primero?",
  "srv.sub": "Toca todo lo que aplique. Tus respuestas deciden qué construimos y cómo lo cobramos.",
  "srv.slots": "Más espacios para ofertas",
  "srv.analytics": "Analíticas y comparativas",
  "srv.placement": "Posición destacada",
  "srv.verification": "Insignia de verificado",
  "srv.followers": "Avisar a mis seguidores",
  "srv.saved": "Gracias, anotado.",
  "bo.title": "Impulsa esta oferta",
  "bo.checking": "Comprobando qué está libre cerca de ti…",
  "bo.slotsLine": "{n} de {limit} espacios patrocinados libres a menos de {km}km de tu negocio",
  "bo.choose": "Elegir",
  "bo.note": "Una lista nunca muestra más de 3 ofertas patrocinadas, así que los negocios se turnan arriba cada hora. Exclusivo es la única opción que no se comparte.",
  "bo.boostTitle": "Boost",
  "bo.boostBody": "Uno de los 3 espacios patrocinados por 7 días, para compradores a menos de 10km.",
  "bo.reachTitle": "Boost + Alcance",
  "bo.reachBody": "El mismo espacio, pero también apareces para compradores hasta 25km — para negocios a los que la gente viaja.",
  "bo.exclTitle": "Exclusivo",
  "bo.exclBlocked": "Exclusivo necesita todos los espacios libres y aún hay {n} boost(s) activos. Libre el {date}.",
  "bst.kindReach": "Alcance {km}km",
  "bst.kindExclusive": "Exclusivo",
  "bst.shareCrowded": "{n} boosts más coincidieron en tu zona, así que tuviste un puesto destacado cerca del {pct}% del tiempo. Con Exclusivo habría sido todo el tiempo.",
  "bst.shareClear": "Tuviste un puesto destacado todo el tiempo: nada más competía cerca.",
  "tfa.enable2fa": "Habilitar 2FA",
  "fn.title": "Cómo los compradores se mueven a través de tus ofertas",
  "fn.subtitle": "Tres pasos reales. Sin puntajes de conversión inventados.",
  "fn.views": "Vistas",
  "fn.grabs": "Capturas",
  "fn.redeemed": "Canjeado en tienda",
  "fn.viewsNote": "Veces que se abrieron tus páginas de ofertas — contado una vez por comprador por día.",
  "fn.grabsNote": "Compradores que tocaron Capturar, así la oferta se guarda en su bolsillo.",
  "fn.redeemedNote": "Códigos que escaneaste en tienda — el único paso que prueba una visita real.",
  "fn.grabRate": "{n}% de vistas",
  "fn.redeemRate": "{n}% de capturas",
  "fn.honestTitle": "Lo que estos números pueden y no pueden decirte",
  "fn.honestBody": "Solo podemos contar las páginas de ofertas abiertas, capturas y códigos que escaneas en tienda. No podemos ver las visitas que no capturaron una oferta, cuánto gastó un cliente o si regresó. Las ofertas sin un código no tienen un paso canjeado.",
  "fn.sourcesTitle": "De dónde vinieron tus vistas",
  "fn.sourcesEmpty": "Aún no hay fuentes de vistas. Comparte una oferta y vuelve a revisar.",
  "fn.sourcesNote": "Las comparticiones son enlaces que tú o los compradores enviaron. Directo significa que no pudimos determinar de dónde comenzó la visita.",
  "fn.last30Days": "Últimos 30 días",
  "fn.nViewsPercent": "{n} vistas · {p}%",
  "fn.nGrabs": "{n} capturas",
  "fn.nRedeemed": "{n} canjeados",
  "fn.directionsTitle": "{n} personas pidieron direcciones",
  "fn.directionsNote": "Toques en Direcciones desde el mapa o la página de la oferta — la señal más fuerte de que alguien se dirigió a tu tienda.",
  "fn.nDirections": "{n} direcciones",
  "map.homeMapNote": "La vista del mapa es tu hogar ahora mismo",
  "map.classicHome": "Inicio clásico",
  "map.homeClassicNote": "¿Prefieres el mapa como tu pantalla de inicio?",
  "map.openMap": "Usar mapa como inicio",
  "map.alertMe": "Avísame aquí",
  "map.alertSignIn": "Inicia sesión gratis para recibir alertas de esta área.",
  "map.alertSaved": "Recibirás una notificación para {area}",
  "map.alertSavedDesc": "{n} ofertas están disponibles aquí ahora, a aproximadamente {km} km. Administra alertas en Seguimiento.",
  "map.alertFailed": "No se pudo guardar la alerta de esa área. Por favor, inténtalo de nuevo.",
  "map.thisArea": "Esta área",
  "map.areasSection": "Alertas de área ({n})",
  "map.areaRadius": "A aproximadamente {km} km",
  "map.areaRemoved": "Alertas desactivadas para {area}",
  "map.shareDialogTitle": "Comparte esta vista del mapa",
  "map.sharePreview": "{n} ofertas en vista — ahorra hasta {best}%",
  "map.sharePreviewNote": "Así es como se verá el enlace cuando alguien lo reciba.",
  "map.shareNoteLabel": "Agrega una nota (opcional)",
  "map.shareNotePlaceholder": "Salida para el almuerzo — ¿nos encontramos en la pastelería?",
  "map.shareNow": "Compartir enlace",
  "map.boostedPin": "Destacado",
  "map.shareCancel": "Cancelar",
  "home.mapTitle": "Ofertas en el mapa",
  "home.mapSubtitle": "{n} ofertas fijadas donde realmente puedes entrar",
  "home.mapOpenFull": "Abrir LyteMap completo",
  "home.mapNote": "Los pines rojos terminan en 24 horas. Los pines con borde dorado son impulsados por la tienda.",
  "ct.subject": "Asunto",
  "ct.sending": "Enviando…",
  "ct.messageTooShort": "Por favor, añade un poco más de detalle para que podamos ayudar.",
  "ct.messageFailed": "No pudimos enviar eso",
  "ct.tryAgainLater": "Por favor, intenta de nuevo en un momento.",
  "ct.replyNote": "Leemos cada mensaje y normalmente respondemos en un día hábil.",
  "lg.boostsIntro": "Un Boost compra atención por un tiempo fijo, así que el momento importa.",
  "lg.boostStartsNowLabel": "Comienza en el momento en que pagas:",
  "lg.boostStartsNow": "un Boost se activa en tu oferta de inmediato y dura los días que compraste, por lo que no se puede cancelar para un reembolso una vez comprado. Si compras uno por error, contáctanos el mismo día y lo resolveremos.",
  "lg.refundTimeline": "Los pagos con tarjeta son manejados por nuestro procesador de pagos (Stripe) — nunca vemos ni almacenamos los detalles de tu tarjeta. Los reembolsos aprobados se envían de vuelta a la misma tarjeta y generalmente aparecen dentro de 5 a 10 días hábiles, dependiendo de tu banco.",
  "bst.reportTitle": "Lo que hicieron tus boosts",
  "bst.reportSub": "Cada boost al lado del mismo período de tiempo justo antes de que comenzara.",
  "bst.running": "En curso",
  "bst.finished": "Terminado",
  "bst.directionsShort": "Direcciones",
  "bst.reportNote": "Los tratos potenciados se turnan en la parte superior — el orden rota cada hora para que cada tienda potenciadas obtenga una parte justa.",
  "bst.slotsLeft": "{n} de {limit} espacios de boost disponibles para {category} en {city} ahora mismo",
  "bst.slotsFull": "Los {limit} espacios de boost para {category} en {city} están activos",
  "bst.slotsNote": "Limitamos los boosts activos a {limit} en {km}km alrededor de cada negocio, para que un pin dorado siga destacando.",
  "bst.slotsLeftNear": "{n} de {limit} espacios de boost disponibles para {category} a menos de {km}km de tu negocio",
  "bst.slotsFullNear": "Los {limit} espacios de boost para {category} a menos de {km}km de tu negocio están activos",
  "bst.nextFree": "El próximo espacio se abre {when}: un boost dura 7 días completos desde el momento de la compra.",
  "bst.notifyMe": "Avísame cuando se libere un espacio",
  "bst.notifyQueued": "Estás en la lista: te avisaremos por correo cuando se libere un espacio de {category}.",
  "bst.ownBoostLive": "\"{title}\" ya tiene boost en {category}: un boost activo por categoría, así nunca compites contra ti mismo.",
  "adn.boostBody": "En la parte superior de Navegar, buscar, el mapa, Próximamente y las filas de ofertas en la página de inicio durante 7 días. Solo se pueden ejecutar 3 impulsos a la vez dentro de un radio de 10 km de tu tienda, así que la insignia sigue teniendo significado.",
  "bo.exclBody": "Tomas los 3 espacios y te posicionas hasta 25 km: tu oferta es la única patrocinada en tu categoría cercana. Máximo dos semanas, luego la categoría se abre nuevamente.",
  "bo.close": "Cerrar",
  "adn.featTitle": "Destacado en la página de inicio",
  "adn.featBody": "Tu oferta ocupa el único espacio Destacado de su categoría en la página de inicio durante 24 horas — la única oferta destacada en esa categoría, mostrada a compradores de todo el mundo. Impulsar te eleva en Navegar, el mapa y la búsqueda; Destacado te coloca en la portada.",
  "adn.featCta": "Destacar desde Mi Cuenta",
  "card.sponsored": "Patrocinado",
  "lg.listingDiscretion": "Mantener LytePress valioso significa que revisamos lo que se publica. Podemos editar, archivar o eliminar cualquier listado, y retirar el acceso al servicio, donde lo consideremos necesario — por ejemplo, contenido que parezca inexacto, inseguro, duplicado o fuera de lugar. Normalmente informaremos al negocio por qué, aunque no tenemos que preguntar primero.",
  "lg.listingModerationRecords": "El contenido que publicas — ofertas, fotos y detalles del negocio — se revisa como parte de la operación del servicio, y una copia de un listado que eliminamos puede permanecer en nuestros registros internos por un período para que podamos manejar apelaciones, disputas y problemas recurrentes.",
  "lg.termsOfUse": "Términos de Uso",
  "lg.privacyPolicy": "Política de Privacidad",
  "bo.excl14Title": "Exclusivo · 2 semanas",
  "bo.excl14Body": "El mismo bloqueo, pagado por adelantado por la quincena completa y más barato que dos semanas individuales. Después, la categoría se reabre para todos.",
  "bo.extendTitle": "Extiende este impulso",
  "bo.extendLine": "Válido hasta {date} — se añaden días extra al final, no pierdes nada.",
  "bo.addDays": "Añadir {n} días",
  "bo.extendNote": "Los días extra comienzan cuando termina tu periodo actual, así que tu oferta nunca sale de los espacios patrocinados a mitad de semana.",
  "bo.exclRunway": "Has mantenido Exclusivo durante {held} de {max} días seguidos. La categoría se reabre para todos hasta {date}.",
  "sr.title": "Espacios patrocinados cerca de ti",
  "sr.sub": "Solo {limit} espacios patrocinados se ejecutan a la vez en cada categoría dentro de {km}km de tu tienda. Aquí está lo que está libre ahora mismo.",
  "sr.loading": "Verificando los espacios alrededor de tu tienda…",
  "sr.open": "{n} de {limit} libres dentro de {km}km",
  "sr.full": "Todos {limit} en funcionamiento ahora mismo",
  "sr.fullNext": "Todos {limit} en funcionamiento — el siguiente se abre el {date}",
  "sr.exclusiveHeld": "Una tienda mantiene Exclusivo aquí hasta el {date}",
  "sr.watch": "Observar",
  "sr.watching": "Observando",
  "sr.watchOn": "Te avisaremos en cuanto se abra un espacio de {category}",
  "sr.watchOff": "Dejaste de observar {category}",
  "sr.buyPass": "Compra un Boost Pass — {price}",
  "sr.passesHeld": "{n} Boost Pass listo para usar",
  "sr.note": "Un Boost Pass es un impulso pagado por adelantado al precio normal — mantenlo hasta que se abra un espacio, luego úsalo con un toque. Nunca expira y no salta la fila, así que el límite se mantiene justo.",
  "fp.title": "Aquí está tu espacio Destacado",
  "fp.honest": "Este es el único espacio Destacado para tu categoría — la única oferta destacada que ven los compradores allí, en todo el mundo.",
  "fp.note": "Destacado es la fila de la portada — un espacio por categoría. Elige tu país (visto por compradores locales) o todo el mundo (visto en todas partes). Dura 24 horas; comprar de nuevo mientras está activo añade otro día al final.",
  "fp.reachLocal": "Mi país",
  "fp.reachLocalNote": "Primero en tu categoría para compradores de aquí",
  "fp.reachGlobal": "En todo el mundo",
  "fp.reachGlobalNote": "Primero en tu categoría en todas partes",
  "fp.today": "Hoy (empezar ahora)",
  "fp.pickDay": "Empieza hoy o reserva un día",
  "fp.notNow": "No ahora",
  "fp.buy": "Destácalo — {price}",
  "bo.extendSame": "Agrega {n} días más a lo que estás corriendo ahora.",
  "bo.extendToReach": "Agrega {n} días y amplía tu alcance de 10km a 25km durante toda la duración.",
  "bo.extendToExclusive": "Agrega {n} días y toma los 3 espacios patrocinados, hasta 25km.",
  "bo.extendNarrower": "Agrega días, pero reduce tu alcance de nuevo a 10km.",
  "pc.placeholder": "Código de descuento",
  "pc.apply": "Aplicar",
  "pc.remove": "Eliminar código",
  "pc.invalid": "Ese código no es válido.",
  "pc.appliedPct": "{code} — {n}% de descuento",
  "pc.appliedAmt": "{code} — ${n} de descuento",
  "pc.haveCode": "¿Tienes un código de descuento?",
  "prc.f2": "Un pin en el mapa y perfil público",
  "prc.p3": "Hasta 3 ubicaciones fijadas",
  "acc.frontPageForDays": "Destacado por 7 días",
  "br.limitNote": "{plan} cubre {cap} ubicación(es) fijada(s). Pro fija 3 y Elite es ilimitado.",
  "br.overLimit": "Tienes más ubicaciones guardadas de las que {plan} cubre ({cap}). Todo lo que ya está publicado se queda en el mapa — actualiza para guardar cambios aquí.",
  "acc.archived": "Archivado",
  "acc.archivedWhy": "Retirado:",
  "acc.archivedNoReason": "No se dio ninguna razón — pregúntanos y te explicaremos.",
  "acc.explainAppeal": "Explica lo que pasó →",
  "sl.shareMsg": "Tenemos {n} ofertas ahora mismo — échale un vistazo:",
  "sl.copy": "Copiar enlace",
  "sl.copied": "Enlace copiado",
  "sl.copiedNote": "Pégalo en cualquier lugar — se abre directamente en la página de tu tienda.",
  "bst.kindFeatured": "Destacado en la página principal, {km}km",
  "bo.extendLocked": "Estás usando {kind} — añade días a eso para que no lo pierdas. Puedes cambiar una vez que termine la duración.",
  "fp.slots": "El espacio Destacado para tu categoría está libre — reclámalo por 24 horas.",
  "fp.full": "El espacio Destacado para tu categoría está ocupado ahora mismo — el siguiente se abre el {date}. Hay un espacio por categoría.",
  "prc.chipFeatured": "Ubicación prioritaria",
  "prc.chipCredits": "Impulsos y destacados como complementos",
  "prc.boostLeft": "{n} Pases de Impulso restantes",
  "prc.p5": "Informes de promoción en cada Impulso o destacado",
  "prc.boostBody": "Los impulsos y las ubicaciones destacadas nunca se agrupan en un plan: cómpralos solo cuando los necesites. Impulsa cualquier oferta única por {price} para fijarla en la parte superior de Navegar y el mapa durante 7 días: encuentra el botón de Impulso en tus ofertas en",
  "acc.usedBoostPass": "Usaste un Pase de Impulso — {n} restantes.",
  "acc.couldNotUseYour": "No se pudo usar tu Pase de Impulso",
  "prc.plusIncludesPro": "Todo en Pro, más:",
  "prc.b4": "Soporte prioritario — tus mensajes saltan la fila",
  "sl.title": "El enlace de tu tienda",
  "sl.sub": "Un enlace para todo lo que tienes — {n} en vivo ahora mismo. Pégalo en WhatsApp y muestra el nombre de tu tienda, logo y cuántas ofertas hay.",
  "sl.on": "Enlace activado",
  "sl.off": "Enlace desactivado",
  "sl.switchedOn": "Tu enlace de tienda está en vivo",
  "sl.switchedOff": "Tu enlace de tienda está desactivado",
  "sl.offNote": "Tu enlace está desactivado, así que no se abrirá para nadie. Actívalo de nuevo cuando quieras compartir.",
  "sl.needVerified": "Los enlaces de tienda vienen con verificación — es lo que impide que alguien más comercie bajo tu nombre. Envía tus documentos y el tuyo se activará automáticamente, construido a partir del nombre de tu negocio.",
  "sl.getVerified": "Verifícate",
  "sl.dealLinks": "Cada oferta también tiene su propio enlace — aquí está “{title}”:",
  "prc.b3": "Ubicación prioritaria en Navegar y el mapa, compartida de manera justa",
  "prc.sp3": "Los límites de ofertas en vivo cuentan las ofertas que están publicadas o programadas y que aún no han expirado — Gratis 2, Pro 15, Elite 100. Elite también cubre 25 ubicaciones fijadas. Estos límites son uso justo, no una pared: si tu cadena necesita más, envía un correo a soporte y los aumentaremos en tu cuenta. La ubicación prioritaria es un desempate entre ofertas que están a la misma distancia del comprador, compartida de manera justa entre las tiendas Elite — nunca coloca una tienda por encima de otra que esté genuinamente más cerca.",
  "prc.firstTermOnly": "{price} por este término con tu código — se renueva a {full}",
  "prc.promoTermOnly": "Los códigos se aplican al término que compras. Las renovaciones se cobran automáticamente al precio habitual, así que el descuento es solo para este primer término.",
  "prc.sp2": "Los planes se renuevan automáticamente para que tu tienda nunca se apague. Pagas por un período (Pro {pro} / 30 días o {proYear} / año; Elite {plus} / 30 días o {plusYear} / año); tu tarjeta se guarda de forma segura en nuestro proveedor de pagos, Stripe, y se cobra automáticamente al inicio de cada nuevo período, hasta que desactives la renovación automática, lo cual puedes hacer en cualquier momento desde esta página. Si un cobro de renovación falla, tu plan sigue funcionando durante un período de gracia de 3 días mientras reintentamos. Un código de descuento se aplica solo al período en el que se usa: las renovaciones se cobran al precio de lista. Los planes nunca incluyen Boosts ni ubicaciones destacadas: esos son cargos únicos, no suscripciones.",
  "lg.proSubscription": "plan (Pro o Elite)",
  "lg.placementShoppersUseLytepress": "ubicación, más un pequeño número de complementos únicos (espacios adicionales para ofertas, un Boost Pass o verificación prioritaria). Los compradores usan LytePress de forma gratuita.",
  "lg.ifYouReNot": "Si no estás satisfecho con un plan, pregúntanos dentro de",
  "lg.afterDaysASubscription": "Un plan se compra por un término (30 días o un año) y se renueva automáticamente. Tu tarjeta se guarda de forma segura en nuestro proveedor de pagos, Stripe —nunca en nosotros— y se cobra al inicio de cada nuevo término para que tu plan continúe sin interrupciones. Puedes desactivar la renovación automática en cualquier momento desde la página de Precios; mantienes todo lo que pagaste hasta que termine el término actual, y no se cobra nada después. Si un cobro de renovación falla, los beneficios de tu plan continúan durante un período de gracia de 3 días mientras reintentamos, tras el cual la cuenta pasa a Gratis. Después de 14 días, un pago por un término ya en curso no es reembolsable, y mantienes todo lo que pagaste hasta que termine ese término.",
  "lg.ifARenewalCharge": "Un código de descuento se aplica solo al término en el que se usó: las renovaciones se cobran al precio de lista. Puedes ver tu fecha de renovación y desactivar la renovación automática en cualquier momento en la página de Precios. Si una renovación te sorprende, contáctanos: donde un término pagado no se utiliza, normalmente lo reembolsaremos como cortesía.",
  "lg.premiumSubscriptionsAndDeal": "Los planes, Boosts, ubicaciones destacadas y complementos se facturan a través de nuestro procesador de pagos. Los Boosts y las ubicaciones destacadas nunca están incluidos en un plan; son compras únicas separadas y están limitadas en número en cada área, por lo que una ubicación solo está disponible mientras haya un espacio libre cerca de tu tienda. La oferta de Elite y las asignaciones de ubicación son límites de uso justo, y \"ubicación prioritaria\" significa solo que una oferta de Elite se muestra primero cuando dos ofertas están a la misma distancia del comprador; nunca coloca una tienda por encima de otra que esté genuinamente más cerca. Las tarifas se muestran antes de la compra. Pueden aplicarse impuestos según tu ubicación. Los reembolsos están cubiertos por nuestro",
  "lg.accountDetailsNameEmail": "Detalles de la cuenta (nombre, correo electrónico, rol), información del perfil del negocio (nombre del negocio, categoría, ubicación, números de contacto, logo/cobertura) y tus preferencias (moneda de visualización, negocios seguidos, ubicación). Si habilitas la autenticación de dos factores, almacenamos un secreto encriptado y códigos de recuperación hash. Si agregas una clave de acceso, almacenamos su clave pública y un contador de firmas. Si envías comentarios o un mensaje de soporte, conservamos el mensaje y tu correo electrónico solo si proporcionaste uno, para poder responder.",
  "lg.businessContactDetailsAre": "Los detalles de contacto del negocio se muestran públicamente solo cuando el negocio decide hacerlos públicos. El enlace público de una tienda verificada (/s/nombre-de-la-tienda) y sus enlaces de ofertas muestran el nombre, logo y ofertas en vivo de esa tienda a cualquiera con el enlace; la tienda puede desactivar ese enlace en cualquier momento. No vendemos tus datos personales. Compartimos datos limitados con nuestro procesador de pagos para completar compras.",
  "lg.passwordsAreHashedFa": "Las contraseñas están hashadas, los secretos de dos factores están encriptados en reposo y las acciones sensibles tienen un límite de tasa. Si agregas una clave de acceso, solo almacenamos su clave pública y un contador; nunca tu huella digital, rostro o PIN del dispositivo, que nunca salen de tu dispositivo. Ningún sistema es perfectamente seguro, así que usa una contraseña fuerte y agrega una clave de acceso o 2FA.",
  "lg.youCanEditYour": "Puedes editar tu perfil, ocultar tu información de contacto pública, gestionar dispositivos y claves de acceso de confianza, activar o desactivar 2FA, desactivar tu enlace público de tienda y ajustar notificaciones en cualquier momento desde Mi Cuenta. Para que se elimine tu cuenta y datos personales, envía un correo a support@lytepress.com y lo haremos en un plazo de 30 días.",
  "lg.proSubscriptionsDayMoney": "3. Planes: cómo funciona la facturación y reembolso de 14 días",
  "lg.lawDisputes": "7. Ley y disputas",
  "lg.termsContact": "8. Contacto",
  "auth.or": "o",
  "fb.button": "Comentarios",
  "fb.title": "Cuéntanos qué piensas",
  "fb.sub": "Cualquier cosa rota, faltante o brillante — llega directamente a nosotros. No se necesita cuenta.",
  "fb.typeBug": "Algo está roto",
  "fb.typeIdea": "Tengo una idea",
  "fb.typeCompliment": "Algo que me encanta",
  "fb.typeOther": "Algo más",
  "fb.messagePlaceholder": "Cuéntanos qué pasó, o qué te gustaría ver…",
  "fb.emailLabel": "Correo electrónico (opcional — solo para que podamos responder)",
  "fb.send": "Envíalo",
  "fb.sent": "Gracias — eso está con nosotros",
  "fb.sentNote": "Una persona lee cada uno de estos. Responderemos si dejaste un correo.",
  "fb.failed": "No se pudo enviar eso",
  "fb.tooShort": "Unas palabras más y sabremos qué arreglar",
  "pk.title": "Claves de acceso",
  "pk.sub": "Inicia sesión con Face ID, tu huella digital o tu PIN del dispositivo. Tu contraseña sigue funcionando como respaldo.",
  "pk.add": "Agregar una clave de acceso",
  "pk.added": "Clave de acceso agregada",
  "pk.addedNote": "La próxima vez, toca \"Iniciar sesión con una clave de acceso\" — sin contraseña que escribir.",
  "pk.removed": "Clave de acceso eliminada",
  "pk.remove": "Eliminar",
  "pk.none": "Sin claves de acceso aún. Agrega una y este dispositivo puede iniciar sesión sin contraseña.",
  "pk.unsupported": "Este navegador aún no soporta claves de acceso; tu contraseña y 2FA siguen funcionando normalmente.",
  "pk.cancelled": "Cancelado",
  "pk.failed": "Eso no funcionó",
  "pk.lastUsed": "Último uso {date}",
  "pk.never": "No se ha utilizado aún",
  "pk.signIn": "Iniciar sesión con una clave de acceso",
  "pk.loginFailed": "No se pudo iniciar sesión",
  "pk.loginFailedNote": "Intenta con tu contraseña, o agrega una clave de acceso desde Mi Cuenta primero.",
  "cq.need": "¿Necesitas más espacio?",
  "cq.title": "Solicitar límites más altos",
  "cq.sub": "Elite cubre {deals} ofertas en vivo y {branches} ubicaciones como uso justo. Cuéntanos lo que realmente necesita tu cadena y lo ajustaremos.",
  "cq.deals": "Ofertas en vivo que necesitas",
  "cq.branches": "Ubicaciones que necesitas",
  "cq.notePlaceholder": "Cualquier cosa que debamos saber — cuántas sucursales tienes, qué planeas…",
  "cq.send": "Enviar solicitud",
  "cq.sentTitle": "Solicitud enviada",
  "cq.sentNote": "Lo revisaremos y te enviaremos un correo — generalmente dentro de un día.",
  "cq.pending": "Límites más altos solicitados — te enviaremos un correo",
  "cq.failed": "No se pudo enviar eso",
  "fb.context": "Envía la página y el dispositivo en el que estoy",
  "fb.contextOn": "Nos ayuda a reproducirlo: {path}, además del tamaño de pantalla, idioma y navegador. Sin cookies ni datos personales.",
  "fb.contextOff": "Solo recibiremos tu mensaje.",
  "pn.title": "Bloquea tu tienda a este dispositivo",
  "pn.body": "Tus ofertas están activas. Agrega una clave de acceso y solo tu rostro, huella dactilar o PIN del dispositivo pueden entrar a esta tienda — sin contraseña que adivinar o robar.",
  "pn.add": "Agregar una clave de acceso",
  "pn.notNow": "No ahora",
  "tm.sortingAround": "Ordenando ofertas alrededor de {place}.",
  "tm.cancel": "Cancelar",
  "tm.nearPlace": "cerca de {place}",
  "tm.you": "tú",
  "tm.changeBase": "cambiar base",
  "tm.yourBases": "Tus bases:",
  "tm.switchedTo": "Cambiado a {label}",
  "pw.placeholder": "Contraseña",
  "pw.show": "Mostrar contraseña",
  "pw.hide": "Ocultar contraseña",
  "pw.veryWeak": "Demasiado débil",
  "pw.weak": "Débil",
  "pw.fair": "Casi ahí",
  "pw.strong": "Fuerte",
  "pw.veryStrong": "Muy fuerte",
  "pw.crackTime": "tomaría {time} para romper",
  "pw.needsWork": "Aún no es lo suficientemente fuerte",
  "prc.bestValue": "MEJOR VALOR",
  "qa.profanity": "Por favor, elimina las groserías primero — encontramos {words}. LytePress es leído por familias y personal de tiendas, así que las ofertas y reseñas deben mantenerse limpias.",
  "sl.customTitle": "Elige tu propio enlace",
  "sl.customPlus": "Incluido con Elite — elige las palabras después de /s/ tú mismo.",
  "sl.customOwned": "Tú posees este complemento — cambia las palabras después de /s/ cuando quieras.",
  "sl.customOffer": "Tu enlace se construye a partir del nombre de tu negocio. ¿Quieres diferentes palabras después de /s/? Cuesta {price} una vez, es tuyo para siempre — o gratis en Elite.",
  "sl.customBuy": "Nombra mi enlace — {price}",
  "sl.customEdit": "Edita mi enlace",
  "sl.customSave": "Guardar enlace",
  "sl.customCancel": "Cancelar",
  "sl.customPlaceholder": "nombre-de-tu-tienda",
  "sl.customSaved": "Tu nuevo enlace está activo",
  "adn.linkTitle": "Elige tu propio enlace de tienda",
  "adn.linkBody": "Elige las palabras después de /s/ tú mismo en lugar de usar el nombre de tu negocio — más corto para decir en voz alta, más fácil de copiar. Es tuyo para siempre, un solo pago.",
  "adn.linkCta": "Nombra mi enlace — {price}",
  "adn.linkIncluded": "Incluido con Elite",
  "adn.linkSetIt": "Establecer mi enlace",
  "adn.linkNeedsVerify": "Los enlaces de tienda requieren verificación — envía tus documentos primero.",
  "rst.thisResetLinkIs": "Este enlace de restablecimiento no es válido, ya se usó o ha expirado. Por favor, solicita uno nuevo a",
  "rst.minChars": "Usa al menos {n} caracteres para esta cuenta.",
  "acc.tabDeals": "Mis ofertas",
  "acc.tabShop": "Mi tienda",
  "acc.tabRedeem": "Canjear",
  "acc.tabAccount": "Cuenta",
  "sec.title": "Detalles de inicio de sesión",
  "sec.sub": "Cambia la contraseña o el correo electrónico con el que inicias sesión.",
  "sec.pwTitle": "Contraseña",
  "sec.pwNote": "Cambiarla cierra sesión en todos los demás dispositivos.",
  "sec.pwCta": "Cambiar contraseña",
  "sec.currentPw": "Contraseña actual",
  "sec.newPw": "Nueva contraseña",
  "sec.pwSave": "Guardar contraseña",
  "sec.pwChanged": "Contraseña cambiada",
  "sec.pwChangedNote": "Todos los demás dispositivos han cerrado sesión.",
  "sec.emailTitle": "Correo electrónico de inicio de sesión",
  "sec.emailCta": "Cambiar correo electrónico",
  "sec.newEmail": "Nueva dirección de correo electrónico",
  "sec.emailSave": "Enviar confirmación",
  "sec.emailConfirmNote": "Enviaremos un enlace a la nueva dirección. Nada cambia hasta que lo toques.",
  "sec.emailSent": "Revisa tu nueva bandeja de entrada",
  "sec.emailSentNote": "Enviamos un enlace de confirmación a {email}. Funciona por 24 horas.",
  "sec.emailPending": "Esperando que {email} confirme.",
  "ses.title": "Dispositivos conectados",
  "ses.sub": "Cierra sesión en cualquier cosa que no reconozcas.",
  "ses.idleNote": "Cerrado automáticamente después de {n} horas sin hacer nada.",
  "ses.thisDevice": "Este dispositivo",
  "ses.signOutAll": "Cerrar sesión en todos lados",
  "ses.signOutDevice": "Cerrar sesión en este dispositivo",
  "ses.signedOutDevice": "Ese dispositivo ha cerrado sesión",
  "ses.signedOutAll": "Cerrado sesión en todos lados",
  "ses.signedOutAllNote": "Todos los demás dispositivos necesitarán iniciar sesión nuevamente.",
  "ses.empty": "No hay otros dispositivos conectados.",
  "auth.endedIdle": "Has cerrado sesión después de un período de inactividad. Inicia sesión para continuar donde lo dejaste.",
  "auth.endedRevoked": "Este dispositivo ha cerrado sesión. Inicia sesión nuevamente para continuar.",
  "pd.maxDays": "Tu plan mantiene una oferta por hasta {n} días. Renueva con un toque cuando termine.",
  "acc.renew": "Renovar",
  "acc.renewTitle": "Devuelve esta oferta al mapa con una nueva cuenta regresiva",
  "acc.renewDone": "Cuenta regresiva reiniciada",
  "acc.renewRelisted": "De vuelta en el mapa",
  "acc.renewNote": "Esta oferta estará activa por {n} días más.",
  "pd.clampedTitle": "Fecha de finalización adelantada",
  "pd.clampedNote": "Tu plan publica una oferta por hasta {n} días, así que aquí es donde termina esta. Renueva con un toque para mantenerla activa.",
  "nd.title": "No hay ofertas aquí todavía",
  "nd.sub": "Dinos dónde estás y buscaremos tiendas en el mapa cerca de ti. Así decidimos dónde ir a buscar a continuación.",
  "nd.townPlaceholder": "Tu ciudad, p.ej. Arima",
  "nd.emailPlaceholder": "Correo electrónico (opcional — te avisaremos cuando lleguen ofertas)",
  "nd.cta": "Quiero ofertas aquí",
  "nd.thanks": "Anotado",
  "nd.thanksNote": "Hemos agregado {place} a la lista.",
  "nd.onTheList": "Estás en la lista",
  "nd.onTheListNote": "Te enviaremos un correo en cuanto las tiendas cerca de ti empiecen a publicar.",
  "map.shareNear": "Comparte las ofertas más cercanas",
  "map.shareNearMsg": "Ofertas cerca de {place} ahora mismo en LytePress:",
  "promo.title": "Gráfico \"Estamos en LytePress\"",
  "promo.sub": "Una imagen cuadrada con tu código QR — publícalo en Instagram, Facebook o tu estado de WhatsApp.",
  "promo.cta": "Descargar imagen",
  "promo.saved": "Imagen guardada",
  "promo.savedNote": "Publícalo y cualquier persona que escanee llegará directamente a tus ofertas.",
  "acc.weeklyRoundup": "Resumen semanal",
  "acc.dealsNearYouWeekly": "Ofertas cerca de ti, una vez a la semana",
  "acc.fiveClosestDeals": "Las cinco ofertas en vivo más cercanas, enviadas por correo una vez a la semana. No más que eso.",
  "acc.digestOn": "Resumen semanal activado",
  "acc.digestOff": "Resumen semanal desactivado",
  "acc.digestOnNote": "Te enviaremos por correo las ofertas más cercanas una vez a la semana.",
  "acc.digestOffNote": "No más correos semanales. Los correos de la cuenta seguirán enviándose.",
  "cat.Travel & Tours": "Viajes y Tours",
  "sr.watchAnother": "Mira otra categoría:",
  "sr.pickCategory": "Elige una categoría",
  "prc.startFree": "Comienza gratis — no se necesita tarjeta",
  "prc.switchAtTermEnd": "Cambia a {plan} cuando termine mi periodo",
  "prc.noProration": "Sin prorrateo — tu periodo actual ya está pagado, así que el cambio espera hasta que termine.",
  "prc.cancelScheduled": "Cancelar el cambio programado",
  "prc.scheduled": "Programado: {plan}",
  "prc.scheduledOn": "Entrará en vigor el {date}. No hay cambios antes de eso.",
  "prc.scheduleCancelled": "Cambio programado cancelado — no hay cambios.",
  "prc.scheduledBanner": "Te mudarás a {plan} el {date}. Todo lo que has pagado seguirá activo hasta entonces.",
  "del.title": "Eliminar mi cuenta",
  "del.subShopper": "Elimina tu cuenta, códigos guardados, favoritos y sesiones. Las reseñas que dejaste permanecen en la tienda como “Usuario eliminado”.",
  "del.subBusiness": "Puedes eliminar tu cuenta una vez que no tengas ofertas activas o programadas y ningún término pagado en curso. Todo se eliminará: tu tienda, ofertas, fotos y pines.",
  "del.cta": "Eliminar mi cuenta",
  "del.warning": "Esto es permanente. No podemos recuperar la cuenta, tus ofertas o tus fotos.",
  "del.passwordPlaceholder": "Tu contraseña",
  "del.typeDelete": "Escribe DELETE para confirmar",
  "del.confirmCta": "Eliminar permanentemente",
  "del.keepAccount": "Mantener mi cuenta",
  "del.done": "Cuenta eliminada",
  "del.doneNote": "Todo ha sido eliminado. Gracias por probar LytePress.",
  "lg.deletingYourAccount": "7. Eliminando tu cuenta",
  "lg.deleteShopper": "Los compradores pueden eliminar su cuenta en cualquier momento desde Mi Cuenta. Esto elimina la cuenta, códigos guardados, favoritos y sesiones activas. Las reseñas que has escrito permanecen en el perfil de la tienda, mostradas como “Usuario eliminado”, porque la calificación de una tienda también es información para otros compradores.",
  "lg.deleteBusiness": "Las empresas solo pueden eliminar una cuenta una vez que no tenga ofertas activas o programadas, y ningún término pagado en curso. Esto protege a los compradores de encontrar pines en el mapa de una tienda que ya no existe, y te protege de perder tiempo que ya has pagado: elimina o deja que tus ofertas expiren, cancela la renovación y elimina una vez que termine el término. Escríbenos si necesitas irte antes.",
  "lg.deleteAdmin": "Podemos cerrar una cuenta nosotros mismos —por ejemplo, por violaciones repetidas de políticas o fraude— incluso una con ofertas activas. Te enviaremos un correo electrónico con la razón cuando lo hagamos.",
  "msg.title": "Mensajes",
  "msg.sub": "Todo lo que te enviamos llega aquí — responde en la app y nos llega directamente.",
  "msg.new": "nuevo",
  "msg.noSubject": "Mensaje",
  "msg.you": "Tú",
  "msg.replyPlaceholder": "Escribe tu respuesta…",
  "msg.send": "Enviar respuesta",
  "msg.sent": "Respuesta enviada — volveremos contigo.",
  "prc.b5": "Tu propio enlace de tienda, lytepress.com/s/tu-nombre (tiendas verificadas)",
  "sec.nudgeTitle": "Bloquea tu tienda con una clave de acceso",
  "sec.nudgeBody": "Tu cuenta guarda tus ofertas, tus precios y tu historial de pagos. Una clave de acceso (Face ID o huella digital) o un código de dos pasos hace que una contraseña robada sea inútil.",
  "sec.nudgePasskey": "Agregar una clave de acceso",
  "sec.nudge2fa": "Activar dos pasos",
  "st.mission": "Nuestra misión es simple: ayudar a las personas a gastar menos en las cosas que ya compran, ayudar a las tiendas locales a llenar horas tranquilas y desperdiciar menos comida y stock en el camino.",
  "an.lockedTitle": "Los insights de Pro están bloqueados",
  "an.lockedCta": "Ve lo que agrega Pro",
  "af.footerLink": "Analíticas",
  "af.badge": "Analíticas de tienda",
  "af.title": "Lo que tus analíticas te muestran",
  "af.subtitle": "Cada tienda obtiene los números principales. Pro y Elite añaden la capa de coaching: tendencias, tiempos y referencias.",
  "af.colMetric": "Lo que ves",
  "af.colFree": "Gratis",
  "af.colPaid": "Pro & Elite",
  "af.rowTotals": "Ofertas activas, expiradas y cerca de expirar",
  "af.rowTraffic": "Total de vistas, capturas, compartidos y seguidores",
  "af.rowDiscount": "Descuento promedio y tasa de conversión",
  "af.rowCategory": "Vistas desglosadas por categoría",
  "af.rowTopDeals": "Tu tabla de líderes de mejores ofertas",
  "af.rowFunnel": "Embudo: vistas a capturas a canjeados",
  "af.rowRedemptions": "Total de canjes y direcciones tomadas",
  "af.rowGoal": "Rastreador de meta de canje mensual",
  "af.rowTrends": "Tendencias de vistas, compartidos y seguidores a lo largo del tiempo",
  "af.rowBestTime": "Mejor hora y mejor día para publicar",
  "af.rowWoW": "Movimiento semana a semana",
  "af.rowBenchmark": "Cómo se comparan tus descuentos con tiendas cercanas",
  "af.rowRedemptionDetail": "Detalle de canje para cada oferta",
  "af.rowMostShared": "Tabla de líderes de más compartidos",
  "af.note": "Pro y Elite ven exactamente las mismas analíticas; no hay nada reservado para el plan más grande. En Gratis, las filas bloqueadas aún aparecen, difuminadas, para que siempre sepas qué hay.",
  "af.seePlans": "Ver planes y precios",
  "af.openMine": "Abrir mis analíticas",
  "af.compareLink": "Ver qué analíticas te da cada plan",
  "an2.doNext": "Haz esto a continuación",
  "an2.tipNearExpiry": "{n} oferta(s) expiran en 48 horas — extiéndelas o ajusta el precio antes de que caduquen",
  "an2.tipDiscount": "Tus descuentos están alrededor del {gap}% por debajo de las tiendas cercanas en tu categoría — intenta {target}% en tu próxima oferta",
  "an2.tipBestTime": "Tus compradores buscan alrededor de {time} en {day} — publica tu próxima oferta justo antes de eso",
  "an2.tipRedeem": "Solo el {rate}% de los códigos obtenidos se usan en la tienda — un recordatorio o una fecha límite cierra esa brecha",
  "an2.tipViewsDown": "Las vistas han bajado {n}% respecto a la semana pasada — una oferta fresca las eleva más rápido que cualquier otra cosa",
  "an2.tipGrabRate": "Solo el {rate}% de los espectadores obtienen tus ofertas — un precio más atractivo o una foto más clara generalmente lo soluciona",
  "an2.tipShares": "Nadie ha compartido tus ofertas aún — envía el enlace de tu tienda a tus propios clientes una vez y observa lo que hace",
  "an2.tipAllGood": "Nada necesita arreglarse hoy — tus números son saludables. Publica algo fresco para mantenerlos así",
  "an2.proMore": "Pro se encarga del resto por ti",
  "an2.grabs": "Códigos obtenidos",
  "an2.subVsLastWeek": "{n}% vs la semana pasada",
  "an2.subOfViews": "{n}% de los espectadores obtienen",
  "an2.subOfGrabs": "{n}% de los canjeados",
  "an2.subExpired": "{n} expirados",
  "an2.trend": "Tendencia",
  "an2.mViews": "Vistas",
  "an2.mRedemptions": "Canjeos",
  "an2.mShares": "Compartidos",
  "an2.mFollowers": "Seguidores",
  "an2.noTrendData": "Nada aquí aún para este.",
  "an2.followersChip": "{n} seguidores",
  "an2.dealTable": "Cómo está cada oferta",
  "an2.colDeal": "Oferta",
  "an2.colViews": "Vistas",
  "an2.colGrabs": "Obtenidos",
  "an2.colRedeemed": "Canjeados",
  "an2.colRate": "Tasa",
  "an2.colShares": "Compartidos",
  "an2.tableNote": "La tasa es códigos canjeados de códigos obtenidos. Una tasa alta significa que la oferta realmente convierte — repítela o poténciala.",
  "an2.tipNearExpiryOne": "Una oferta expira en 48 horas — extiéndela o ajusta el precio antes de que caduque",
  "an2.tableNoteFree": "Pro añade canjes, tasa de canje y compartidos para cada oferta en esta tabla.",
  "af.rowActions": "“Haz esto a continuación” — las mejoras que valen la pena, según tus propios números",
  "af.onePick": "1 de 3",
  "af.rowDealTable": "Una tabla: cada oferta con vistas y capturas",
  "af.rowCompetition": "Rivales cercanos y sus descuentos, uno al lado del otro",
  "pd2.moreOptions": "Más opciones",
  "pd2.moreHint": "Estos se quedan como los dejaste la última vez, así que la mayoría de las ofertas solo necesitan una foto, un título y un precio.",
  "pd2.codesOn": "códigos activados",
  "pd2.featuredOn": "destacado",
  "pd2.endToday": "Hoy",
  "pd2.end3": "3 días",
  "pd2.end7": "7 días",
  "pd2.end14": "14 días",
  "pd2.endPick": "Elige una fecha",
  "pd2.endsAt": "Termina {date} a las {time} ({gmt})",
  "pd2.exactTime": "Hora de finalización exacta",
  "pd2.addSpot": "Fijar un lugar diferente",
  "pd2.descHint": "Los compradores deciden a partir de esto. Se necesitan {n} caracteres más.",
  "pd2.descOk": "Los compradores deciden a partir de este — buena longitud.",
  "pd2.writeForMe": "Escríbelo por mí",
  "pd2.undoDraft": "Deshacer",
  "pd2.draftFailed": "No se pudo escribir un borrador en este momento",
  "pd2.photoFirst": "Agrega una foto primero y el borrador describirá lo que realmente hay en él.",
  "pd2.draftNoPhoto": "Escrito solo a partir del título; agrega una foto para un borrador más claro.",
  "pc.yourPlan": "plan {plan}",
  "pc.freeForever": "Gratis, por el tiempo que desees.",
  "pc.lifetime": "Tuyo de por vida — sin renovación.",
  "pc.renews": "Se renueva {date}",
  "pc.autoRenewsOn": "Se renueva automáticamente el {date}",
  "pc.autoRenewOff": "Renovación automática desactivada — el plan termina el {date}",
  "pc.cancelAutoRenew": "Cancelar renovación automática",
  "pc.resumeAutoRenew": "Reactivar renovación automática",
  "pc.updateCard": "Actualizar tarjeta",
  "pc.renewNow": "Renovar ahora",
  "pc.graceMsg": "Renueva ahora — tu plan caducó; los beneficios terminan en {n} días.",
  "pc.billingFail": "No se pudo abrir el portal de facturación. Inténtalo de nuevo.",
  "pc.renewOffToast": "Renovación automática desactivada — tu plan sigue hasta su fecha de fin",
  "pc.renewOnToast": "Renovación automática reactivada",
  "pc.renewFail": "No se pudo actualizar la renovación automática. Inténtalo de nuevo.",
  "pc.buyDeals": "Compra ofertas adicionales",
  "bh.title": "Historial de facturación",
  "bh.subtitle": "Cada cargo, con un código de recibo que puedes citarnos para verificar una compra.",
  "bh.loading": "Cargando tus recibos…",
  "bh.empty": "Aún no hay pagos.",
  "bh.invoice": "Factura",
  "bh.paid": "pagado",
  "bh.pending": "sin finalizar",
  "bh.refunded": "reembolsado",
  "pc.upgrade": "Mejorar",
  "pc.nOfMThisMonth": "{n} de {m} ofertas publicadas este mes",
  "pc.unlimitedThisMonth": "Ofertas ilimitadas este mes",
  "pc.nLeft": "{n} restantes",
  "pc.noneLeft": "Ninguna restante este mes",
  "pc.resets": "Tu cuota se reinicia {date}",
  "pc.creditsHeld": "Ofertas adicionales retenidas",
  "pc.nCreditsHeld": "{n} ofertas adicionales retenidas",
  "pc.locations": "Ubicaciones fijadas",
  "pc.nBought": "{n} compradas",
  "pc.maxDays": "Días que puede durar una oferta",
  "pc.creditNote": "Las ofertas adicionales solo se utilizan una vez que se agota tu cuota mensual, y nunca expiran.",
  "tu.title": "¿Necesitas más ofertas este mes?",
  "tu.sub": "Las ofertas adicionales nunca expiran y solo se utilizan una vez que se agota tu cuota mensual.",
  "tu.youHold": "Tienes {n} en este momento.",
  "tu.each": "{price} cada una",
  "tu.perMonth": "/ 30 días",
  "tu.buy": "Comprar",
  "tu.locationsTitle": "Ubicaciones adicionales en el mapa",
  "pc.rolledOver": "Se trasladó del mes pasado",
  "pc.rollsOverNote": "Las ofertas no utilizadas se trasladan al próximo mes, hasta {cap}.",
  "pc.noRollover": "Reinicios gratuitos el 1° — los planes de pago trasladan ofertas no utilizadas.",
  "pc.boughtNote": "Comprado o regalado. Nunca expiran, incluso en Free.",
  "pc.maxDaysShort": "Una oferta puede durar hasta {n} días",
  "prc.f1": "4 ofertas al mes, se reinicia el 1, hasta 14 días cada una",
  "prc.p1": "30 ofertas al mes — las no utilizadas se acumulan, hasta 30 días cada una",
  "prc.b1": "150 ofertas al mes — las no utilizadas se acumulan, hasta 60 días cada una",
  "prc.b2": "25 ubicaciones fijadas, y puedes comprar más",
  "pd2.titleSuggested": "Título más atractivo:",
  "pd2.useTitle": "Usarlo",
  "pd2.dismissTitle": "Mantener el mío",
  "pd2.undoTitleChange": "Deshacer título",
  "pw.placeholder8": "Contraseña (mínimo 8 caracteres)",
  "pw.placeholder12": "Contraseña (mínimo 12 caracteres)",
  "prc.rollFree": "Se reinicia el 1. Lo gratis no acumula ofertas no utilizadas.",
  "prc.rollPro": "Las ofertas no utilizadas se acumulan por un mes, hasta 30 — así que un mes tranquilo puede dejarte 60 para publicar el próximo mes.",
  "prc.rollPlus": "Las ofertas no utilizadas se acumulan por un mes, hasta 150 — así que un mes tranquilo puede dejarte 300 para publicar el próximo mes.",
  "prc.rollAddon": "Las ofertas adicionales compradas como complementos nunca caducan.",
  "prc.rolledIn": "{n} se trasladaron del mes pasado",
  "acc.emailFreqIntro": "¿Con qué frecuencia deberíamos enviarte correos sobre ofertas y descuentos?",
  "acc.freq_instant": "En cuanto suceda",
  "acc.freq_instant_note": "Un correo por oferta, limitado a uno al día para que no te inunde.",
  "acc.freq_daily": "Una vez al día",
  "acc.freq_daily_note": "Todo lo del día en un solo correo. Recomendado.",
  "acc.freq_weekly": "Una vez a la semana",
  "acc.freq_weekly_note": "Un resumen a la semana, nada en medio.",
  "acc.freq_off": "Sin correos de marketing",
  "acc.freq_off_note": "Nada promocional. Aún verás todo en la app.",
  "acc.emailFreqSaved": "Frecuencia de correo guardada",
  "acc.emailCapNote": "Cualquiera que elijas, nunca enviamos más de un correo de marketing al día o tres a la semana.",
  "an3.withinRadius": "Competidores dentro de",
  "an3.anywhere": "Cualquier lugar",
  "an3.radiusSummary": "{n} tiendas {cat} con ofertas activas dentro de {km} km de tu ubicación.",
  "an3.radiusSummaryAny": "{n} tiendas {cat} con ofertas activas, las más cercanas primero.",
  "an3.noneInRadius": "No hay otra tienda {cat} con una oferta dentro de {km} km de ti — ese espacio es tuyo.",
  "an3.noneAnywhere": "No hay otra tienda {cat} con una oferta activa en este momento — ese espacio es tuyo.",
  "an3.radiusLocked": "Competidores cercanos por distancia es una función de Pro.",
  "an3.radiusNoPin": "Fija tu tienda en el mapa y podemos medir las tiendas a tu alrededor.",
  "an3.pinMyShop": "Fijar mi tienda",
  "pw.acceptWeak": "Entiendo que esta contraseña es débil y quiero usarla de todos modos",
  "pw.suggest": "Sugiéreme una contraseña",
  "pw.memorable": "Fácil de recordar",
  "pw.random": "Aleatoria",
  "pw.words": "Palabras:",
  "pw.reroll": "Nueva sugerencia",
  "pw.copy": "Copiar",
  "pw.suggestNote": "Úsala y guárdala en un lugar seguro. Ya cumple nuestras reglas de seguridad.",
  "auth.staffPortal": "Portal del personal",
  "auth.staffSignIn": "Acceso del personal",
  "auth.staffPortalNote": "Inicia sesión con tu cuenta de administrador.",
  "pw.floorNote": "Cada contraseña necesita al menos 8 caracteres, una letra mayúscula y un símbolo.",
  "tu.credits_5.label": "5 ofertas extra",
  "tu.credits_5.note": "Cinco ofertas extra además de tu cuota mensual. Nunca expiran.",
  "tu.credits_20.label": "20 ofertas extra",
  "tu.credits_20.note": "Veinte ofertas extra a 75c cada una en lugar de $1. Nunca expiran.",
  "tu.credits_50.label": "50 ofertas extra",
  "tu.credits_50.note": "Cincuenta ofertas extra a 60c cada una — la forma más económica de publicar muchas. Nunca expiran.",
  "tu.branch_1_30d.label": "1 ubicación extra",
  "tu.branch_1_30d.note": "Fija una ubicación más por 30 días. Cómprala de nuevo para mantenerla.",
  "tu.branch_5_30d.label": "5 ubicaciones extra",
  "tu.branch_5_30d.note": "Fija cinco ubicaciones más por 30 días. Cómpralas de nuevo para mantenerlas.",
  "acc.quietTitle": "Horas tranquilas",
  "acc.quietNote": "Nada promocional llega durante la noche — espera hasta la mañana.",
  "acc.quietFrom": "Tranquilo desde",
  "acc.quietTo": "hasta",
  "acc.quietYourTime": "tu hora local",
  "acc.quietSaved": "Horas tranquilas guardadas",
  "pw.leaked": "Visto en {n} filtraciones de datos conocidas — los atacantes intentan esto primero.",
  "auth.backToLogin": "Volver a iniciar sesión",
  "auth.demoLabel": "Demostración:",
  "acc.nextEmailAt": "Próximo correo: {when}",
  "acc.nextEmailOff": "No te enviaremos nada promocional.",
  "acc.nextEmailSoon": "en cualquier momento",
  "acc.nextEmailToday": "hoy después de {time}",
  "acc.nextEmailTomorrow": "mañana después de {time}",
  "acc.nextEmailWaiting": "{n} esperando ser agrupados",
  "an3.myCategory": "mi categoría",
  "lg.asIsTitle": "Servicio proporcionado tal cual",
  "lg.asIsBody": "LytePress es una plataforma en evolución, y aunque nos esforzamos por ofrecer una experiencia confiable y sin interrupciones, pueden ocurrir errores o tiempos de inactividad ocasionales. Al usar LytePress, reconoces que lo haces bajo tu propio criterio y riesgo. No podemos garantizar un servicio ininterrumpido ni aceptar responsabilidad por pérdidas derivadas del uso de la plataforma. Si encuentras algún error o problema, te animamos a notificarnos para que podamos resolverlo lo más rápido posible. Agradecemos tu comprensión y apoyo mientras seguimos mejorando LytePress.",
  "lg.asIsShort": "LytePress sigue creciendo y cambiando. Se proporciona tal cual: lo usas bajo tu propio criterio y riesgo, y si algo falla, por favor dínoslo para que podamos solucionarlo.",
  "lg.passwordRules": "Cada contraseña necesita al menos 8 caracteres, una letra mayúscula y un símbolo, y no puede contener tu propio nombre, el nombre de la tienda o el correo electrónico. Las cuentas de tienda y administrador necesitan 12 caracteres. Comprobamos las nuevas contraseñas contra listas públicas de contraseñas filtradas: una cuenta de tienda o administrador no puede usar una que aparezca en una filtración, y un comprador que elija una contraseña débil o filtrada debe confirmar que acepta el riesgo.",
  "lg.quotaTerms": "Los planes de pago incluyen un número mensual de ofertas que puedes publicar (una cuota), no una garantía de vistas, clics o ventas. Las ofertas no utilizadas en un plan de pago se transfieren por un mes solamente, con un límite de un mes. Las ofertas compradas como complementos no caducan. Una cuota es un límite de uso justo y podemos ajustar los límites con aviso.",
  "lg.aiHelp": "Copia de oferta asistida por IA",
  "lg.aiHelpBody": "Ofrecemos una herramienta opcional que redacta un título y descripción de oferta a partir de los detalles y la foto que proporciones. El borrador es solo una sugerencia: tú decides si usarlo, puedes editarlo o deshacerlo, y sigues siendo responsable de todo lo publicado en tu oferta, incluyendo precisión, afirmaciones y cumplimiento legal. Tu solicitud y la primera foto se envían a nuestro proveedor de IA para producir el borrador. Limitamos cuántos borradores puede solicitar cada tienda por día y podemos desactivar la herramienta en cualquier momento.",
  "lg.emailsWeSend": "Correos que enviamos",
  "lg.emailsWeSendBody": "Los correos de cuenta, seguridad, pago y moderación son parte del servicio y siempre se envían. El correo promocional —alertas de nuevas ofertas, resúmenes y promociones— está limitado a un correo al día y tres a la semana por cuenta, y tú eliges con qué frecuencia quieres saber de nosotros (a medida que sucede, diariamente, semanalmente o no en absoluto) más horas de silencio cuando no se envía nada promocional. Cada correo promocional lleva un enlace para darse de baja, y enviamos en el idioma que usas en el sitio donde tenemos esa redacción.",
  "lg.quotasAndCredits": "5. Cuotas mensuales y ofertas extra",
  "lg.quotasAndCreditsBody": "La cuota mensual de ofertas de un plan se restablece el día 1. En los planes de pago, las ofertas no utilizadas se transfieren por un mes solamente, con un límite de un mes, y no tienen valor en efectivo: una cuota no utilizada no es reembolsable y no puede ser transferida entre cuentas. Las ofertas o ubicaciones adicionales compradas como complementos no son reembolsables una vez que se ha utilizado cualquier parte; si no se ha utilizado ninguna, pregúntanos dentro de los 14 días y te reembolsaremos.",
  "lg.collectLangEmail": "También almacenamos el idioma en el que lees el sitio (para que nuestros correos coincidan), la frecuencia de tus correos y la configuración de horas de silencio, y un registro de qué correos promocionales te hemos enviado para poder honrar los límites diarios y semanales.",
  "lg.sharingAi": "Cuando usas la herramienta opcional de redacción de ofertas con IA, el texto que ingresaste y la primera foto de la oferta se envían a nuestro proveedor de IA para generar el borrador. No les enviamos tu nombre, correo electrónico o detalles de la cuenta, y no usamos tus ofertas para entrenar modelos de nadie.",
  "lg.breachCheckPrivacy": "Cuando estableces una contraseña, la comprobamos contra listas públicas de contraseñas filtradas utilizando un método donde solo los primeros cinco caracteres de un hash unidireccional salen de nuestro servidor: tu contraseña y el hash completo, nunca lo hacen. Si ese servicio no está disponible, simplemente omitimos la verificación.",
  "lg.privacyEmailChoices": "Tú controlas el correo promocional desde Mi Cuenta: elige a medida que sucede, diariamente, semanalmente o ninguno, establece horas de silencio en tu propia zona horaria, o usa el enlace de baja en cualquier correo promocional. Los correos de cuenta, seguridad y pago no se pueden desactivar mientras tu cuenta esté abierta.",
  "acc.browseDealsArrow": "Explorar ofertas →",
  "acc.verifiedRedemptionsOnly": "Solo redenciones verificadas en tienda.",
  "acc.approxIn": "aprox. en {cur}",
  "an3.sameSpot": "Mismo lugar",
  "an3.underTenth": "menos de 0.2 km",
  "an3.kmAway": "{km} km",
  "an3.nearestOf": "más cercanos de {n} ubicaciones",
  "an3.rivalsHidden": "{n} tiendas rivales tienen ofertas aquí.",
  "an3.rivalsHiddenNote": "Pro y Elite te muestran quiénes son, a qué distancia están y cuánto descuentan.",
  "an3.liveCount": "{n} en vivo",
  "bo.fitShorter": "Tu oferta termina en {days} días, así que esto dura {days} en lugar de {full} — precio ajustado.",
  "bo.fitTooShort": "Esta oferta termina en menos de un día. Renueva o extiéndela primero y el tiempo completo es tuyo.",
  "an3.locationsCount": "{n} ubicaciones",
  "an3.locationN": "Ubicación {n}",
  "an3.legendYou": "Tú",
  "an3.legendRival": "Rival · % de descuento promedio",
  "an3.compareRival": "Compara con mis ofertas",
  "auth.agreeCheckbox": "He leído y estoy de acuerdo con el",
  "lg.setOutBelow": "detalles en las secciones de facturación a continuación",
  "acc.rivalAlertsTitle": "Avísame cuando un rival baje más",
  "acc.rivalAlertsNote": "Un aviso a la semana, como máximo, cuando una tienda dentro de 10 km en tu categoría publique una oferta al menos 10 puntos más baja que tu promedio actual. Solo Pro y Elite.",
  "acc.rivalAlertsOn": "Las alertas de rivales están activadas",
  "acc.rivalAlertsOff": "Las alertas de rivales están desactivadas",
  "st.asWeExpandThroughout": "A medida que crecemos en nuevas ciudades y mercados, nuestro objetivo es convertirnos en el destino más confiable para descubrir ofertas locales, promociones, experiencias y oportunidades.",
  "st.valSustainable": "Fomentar el consumo sostenible en cada mercado que atendemos.",
  "st.lytepressIsAGrowing": "LytePress es una comunidad en crecimiento que conecta a las personas con negocios locales, recompensa el gasto inteligente, apoya el emprendimiento y fomenta el consumo sostenible.",
  "lg.contact2": "8. Contacto",
  "lg.whoWeAre": "1. Quiénes somos",
  "lg.informationWeCollect": "2. Información que recopilamos",
  "lg.howWeUseIt": "3. Cómo lo usamos",
  "lg.location": "4. Ubicación",
  "lg.sharing": "5. Compartir",
  "lg.security": "6. Seguridad",
  "lg.yourChoices": "7. Tus opciones",
  "lg.whoWeAreBody": "LytePress es el nombre legal de la entidad que opera esta plataforma, registrada en Trinidad y Tobago, y es el controlador de datos para la información descrita aquí. Servimos a negocios y compradores en todo el mundo, por lo que tu información puede ser procesada en otros países por los proveedores listados bajo Compartir. Preguntas sobre tus datos: support@lytepress.com.",
  "lg.lawDisputesBody": "LytePress es el nombre legal de la entidad que opera esta plataforma y está registrada en Trinidad y Tobago, mientras que el servicio en sí está disponible para negocios y compradores en todo el mundo; donde estamos registrados no limita donde operamos. Estos términos están regidos por las leyes de Trinidad y Tobago, y sus tribunales tienen jurisdicción sobre cualquier disputa. Esto no afecta los derechos que tienes bajo la ley del consumidor del país en el que vives, y no limita los países que sirve LytePress. Háblanos primero a support@lytepress.com; casi todo se resuelve más rápido de esa manera.",
  "lg.plainSummary": "LytePress (\"nosotros\") permite a los negocios publicar sus ofertas y a los compradores encontrar las ofertas a su alrededor, dondequiera que comercien. Estas páginas están escritas en un lenguaje sencillo a propósito, y si algo aquí no está claro, puedes enviar un correo a support@lytepress.com y una persona te lo explicará. Al usar LytePress, aceptas los puntos a continuación.",
  "qa.firstDealPending": "Primera oferta — en revisión",
  "qa.firstDealPendingMsg": "Damos un vistazo rápido a la primera oferta de una nueva tienda antes de que aparezca en el mapa. Generalmente se activa en un par de horas, y cada oferta después de esta se publica de inmediato.",
  "rpt.notHonoured": "La oferta no fue honrada",
  "rpt.notHonouredSent": "Reporte enviado",
  "rpt.notHonouredThanks": "Gracias por informarnos",
  "rpt.notHonouredNote": "Esto va directamente a nuestro equipo de moderación y lo seguimos con la tienda.",
  "rpt.notHonouredHelp": "¿Entraste y la tienda rechazó esta oferta? Un toque nos lo dice — no hay formulario que llenar.",
  "ver.title": "Confirma tu correo electrónico para publicar ofertas",
  "ver.note": "Enviamos un enlace y un código de 6 dígitos a {email}. Las ofertas que publiques están en espera hasta que confirmes; se activan en el momento en que lo hagas.",
  "ver.codePlaceholder": "000000",
  "ver.confirmCode": "Confirmar",
  "ver.resend": "Enviar de nuevo",
  "ver.sent": "Correo en camino",
  "ver.sentNote": "Revisa {email} — el enlace y el código funcionan.",
  "ver.couldNotSend": "No se pudo enviar ese correo",
  "ver.badCode": "Ese código no funcionó",
  "ver.done": "Correo confirmado",
  "ver.doneNote": "Todo listo — cualquier cosa que tenías en espera se activa ahora.",
  "ver.checking": "Confirmando tu correo...",
  "ver.badLink": "Ese enlace no funcionó",
  "ver.badLinkNote": "Puede que haya expirado o ya se haya utilizado.",
  "ver.useCodeInstead": "Escribe el código de 6 dígitos del correo en el banner de tu panel en su lugar.",
  "ver.noToken": "Este enlace no tiene su código.",
  "ver.goToAccount": "Ir a mi cuenta",
  "qa.emailPending": "Confirma tu correo primero",
  "qa.emailPendingMsg": "Tu oferta está guardada y en espera. Toca el enlace en el correo que te enviamos — o escribe el código de 6 dígitos en el banner de tu panel — y se activará de inmediato.",
  "ver.enterCodeHere": "Escribe aquí el código de 6 dígitos del correo electrónico",
  "ver.manualTitle": "Confirma tu correo electrónico",
  "ver.manualNote": "Abre el correo que te enviamos y escribe su código de 6 dígitos abajo. No es necesario que estés conectado.",
  "ver.needANewOne": "¿Perdiste el correo o el código ha expirado?",
  "ver.emailPlaceholder": "El correo con el que te registraste",
  "ver.sendNewEmail": "Enviar un nuevo correo",
  "ver.emailSentShort": "Correo enviado",
  "vf.unlocks": "Hasta que estés verificado, puedes publicar 2 ofertas a la vez desde una ubicación, y la colocación pagada permanece cerrada. La verificación levanta los tres.",
  "qa.liveCapTitle": "Ese es tu límite de ofertas en vivo",
  "sr.passNeedsVerification": "Los pases Boost se activan una vez que tu negocio esté verificado.",
  "ver.domainTip": "Consejo: confirmar una dirección en tu propio dominio de negocio (no Gmail ni Hotmail) levanta tus límites de ofertas en vivo y ubicación de inmediato.",
  "vf.domainTier": "Correo de dominio confirmado",
  "vf.domainTierNote": "Confirmaste un código enviado a {domain}, una dirección en tu propio dominio de negocio, así que tus límites de comercio ya están levantados. La colocación pagada aún espera tus documentos.",
  "br.pinFarFromListing": "{branch} está fijado a aproximadamente {distance} km de la lista de Google que encontramos bajo tu nombre — {listing}, {address}. Si el pin es incorrecto, los compradores que toquen Direcciones serán enviados a un lugar donde no estás. Arrástralo hasta tu puerta y guarda.",
  "br.thisPin": "Este pin",
  "fx.title": "¿Mover este pin?",
  "fx.summary": "{business} tiene {branch} fijado a {distance} km de la lista de Google que encontramos bajo tu nombre — {listing}{address}.",
  "fx.legend": "Rojo es donde está tu pin ahora. Verde es la lista. Confirmar mueve el pin guardado y el mismo pin en tus ofertas activas. Si tu pin está correcto y la lista pertenece a otra persona, simplemente cierra esta página — nada cambia.",
  "fx.confirm": "Sí, mueve mi pin aquí",
  "fx.now": "Ahora",
  "fx.listing": "Lista",
  "fx.moved": "Pin movido",
  "fx.movedNote": "{branch} ahora está en {address}. Tus ofertas activas también se actualizaron, así que Direcciones enviará a los compradores al lugar correcto de ahora en adelante.",
  "fx.yourPin": "Tu pin",
  "fx.yourListing": "tu lista de Google",
  "fx.aLocation": "una ubicación",
  "fx.expired": "Ese enlace ha expirado",
  "fx.expiredNote": "Los enlaces de un toque duran 14 días. Aún puedes mover el pin tú mismo desde Mi Cuenta.",
  "fx.cantUse": "No podemos usar ese enlace",
  "fx.checking": "Verificando ese enlace…",
  "fx.noCode": "Ese enlace le falta su código. Abre el correo nuevamente.",
  "fx.invalid": "Ese enlace ya no es válido.",
  "fx.failed": "No se pudo mover ese pin.",
  "fx.openAccount": "Abrir Mi Cuenta",
  "fx.byHand": "para mover cualquier pin manualmente.",
  "pv.verifiedOn": "Precio verificado {date}",
  "pv.checkFirst": "Verifica el precio antes de ir",
  "pv.changed": "Los compradores dicen que este precio cambió",
  "pv.tooltip": "La última vez que alguien respaldó este precio.",
  "pv.countOne": "1 comprador lo ha confirmado",
  "pv.countMany": "{n} compradores lo han confirmado",
  "pv.shopperHelp": "¿Has estado aquí recientemente? Dile a los demás si este precio sigue vigente.",
  "pv.ownerHelp": "¿Sigue siendo tu precio? Un toque vuelve a sellar esta oferta como verificada hoy.",
  "pv.signInHint": "Inicia sesión como comprador para confirmar este precio.",
  "pv.stillRight": "El precio sigue siendo correcto",
  "pv.priceChanged": "Precio cambiado",
  "pv.youConfirmed": "Has confirmado este precio.",
  "pv.youFlagged": "Nos dijiste que este precio cambió.",
  "pv.thanksConfirmed": "Gracias — precio verificado",
  "pv.thanksConfirmedMsg": "Cada comprador que vea esta oferta ahora sabe que el precio es actual.",
  "pv.thanksFlagged": "Gracias por el aviso",
  "pv.thanksFlaggedMsg": "Le pediremos a la tienda que vuelva a declarar el precio.",
  "pv.couldNotSave": "No se pudo guardar eso",
  "pv.wasItRight": "¿Estuvo bien el precio?",
  "pv.yesRight": "Sí, exacto",
  "pv.noChanged": "No, cambió",
  "footer.cities": "Ciudades",
  "cities.seoTitle": "Ofertas por ciudad",
  "cities.seoDesc": "Cada ciudad con ofertas activas en LytePress, además de los lugares que estamos abriendo próximamente.",
  "cities.heading": "Ofertas por ciudad",
  "cities.subline": "Elige tu ciudad y ve qué hay disponible ahora. Nuevas ciudades aparecerán aquí tan pronto como las tiendas comiencen a publicar.",
  "cities.openingSoon": "Abriendo pronto",
  "city.seoTitle": "Ofertas en {city}, {country}",
  "city.seoDescEmpty": "LytePress se está abriendo en {city}, {country}. ¿Conoces una tienda que debería estar aquí? Invítala.",
  "city.heading": "Ofertas en {city}",
  "city.sublineEmpty": "Estamos abriendo en {city}, {country}. Aún no hay ofertas aquí.",
  "city.liveDeals": "{n} ofertas activas",
  "city.shops": "{n} tiendas",
  "city.onTheMap": "Verlas en el mapa",
  "city.allCities": "Todas las ciudades",
  "city.noPage": "Aún no hay página de ofertas para esa ciudad.",
  "city.emptyTitle": "Nada activo en {city} aún",
  "city.emptyBody": "Abrimos una ciudad en el momento en que una tienda publica allí. Si conoces algún lugar en {city} que merezca un lugar en el mapa, envíanoslo — toma un minuto y es gratis.",
  "city.browseEverywhere": "Explorar ofertas en todas partes",
  "city.aboutTitle": "Acerca de las ofertas en {city}",
  "city.aboutBody": "LytePress lista lo que las tiendas locales en {city}, {country} han rebajado en este momento — principalmente {cats}. Cada oferta muestra el precio, lo que era, cuánto tiempo dura y exactamente a dónde ir.",
  "city.aboutTrust": "Los precios llevan la fecha en que fueron confirmados por última vez, y los compradores que han estado pueden decirle a los demás si un precio sigue vigente. Nada aquí es una suposición.",
  "city.everyCategory": "todas las categorías",
  "city.nearbyTitle": "Otras ciudades",
  "city.otherLanguages": "Leer esto en",
  "city.seoDesc": "{deals} de {shops} en {city}, {country}. Precios confirmados por compradores, actualizados todos los días.",
  "city.subline": "{deals} de {shops} en {city}, {country} — con precios que han confirmado los compradores.",
  "city.liveDealOne": "1 oferta activa",
  "city.shopOne": "1 tienda",
  "loc.following": "Siguiendo tu ubicación",
  "loc.followingLive": "Siguiéndote mientras te mueves",
  "loc.notFollowing": "Ubicación fijada aquí",
  "loc.turnOff": "apagar",
  "loc.turnOn": "sígueme de nuevo",
  "loc.goLive": "seguir mientras me muevo",
  "loc.stopLive": "dejar de seguir en vivo",
  "loc.nearCity": "Estás cerca de {city}",
  "loc.seeThoseDeals": "Ver esas ofertas",
  "pd.quietHours": "Oferta de horas tranquilas",
  "pd.quietHoursHint": "Un descuento permanente que se repite — como de 3pm a 5pm en días de semana, para llenar el vacío.",
  "pd.quietFrom": "Desde",
  "pd.quietTo": "Hasta",
  "pd.quietNote": "Los compradores aún ven la oferta fuera de estas horas — se muestra cuándo comienza, y los códigos solo funcionan dentro de la ventana.",
  "pd.mon": "Lun",
  "pd.tue": "Mar",
  "pd.wed": "Mié",
  "pd.thu": "Jue",
  "pd.fri": "Vie",
  "pd.sat": "Sáb",
  "pd.sun": "Dom",
  "time.am": "am",
  "time.pm": "pm",
  "qh.onUntil": "Hasta {time}",
  "qh.starts": "Comienza {time}",
  "qh.runs": "Dura {days}, {from} a {to}",
  "qh.weekdays": "días de semana",
  "qh.weekends": "fines de semana",
  "qh.everyDay": "cada día",
  "pitch.print": "Imprimir ambas hojas",
  "pitch.printHint": "Dos páginas: esta ciudad, luego qué es LytePress. Imprimir o guardar como PDF.",
  "pitch.cityHeading": "{city} ya está en el mapa.",
  "pitch.citySub": "Esto es lo que los compradores en {city}, {country} ven cuando abren LytePress y buscan algo que valga la pena salir de casa.",
  "pitch.statDeals": "Ofertas en vivo",
  "pitch.statShops": "Tiendas listadas",
  "pitch.statTop": "Más listadas",
  "pitch.mapTitle": "El mapa hoy",
  "pitch.yourSpot": "Tu lugar",
  "pitch.noMapKey": "Mapa no disponible",
  "pitch.alreadyOn": "Ya en LytePress aquí",
  "pitch.claimTitle": "Hay un vacío en {city}.",
  "pitch.claimBody": "Escanea para reclamar tu lugar. La lista es gratuita, toma unos dos minutos, y tu primera oferta puede estar activa hoy.",
  "pitch.qrCityPage": "Ver ofertas de {city}",
  "pitch.qrClaim": "Reclama tu lugar",
  "pitch.aboutHeading": "Qué es LytePress.",
  "pitch.aboutLine": "Un mapa de ofertas reales de tiendas reales. Los compradores lo abren para ver qué está rebajado cerca de ellos en este momento — y cada precio lleva la fecha en que alguien estuvo detrás de él por última vez.",
  "pitch.mapCaption": "Cada pin es una tienda con una oferta en vivo.",
  "pitch.forShoppers": "Para compradores",
  "pitch.shopper1": "Ve qué está rebajado a poca distancia, en este momento, con direcciones a la puerta.",
  "pitch.shopper2": "Cada precio muestra cuándo fue confirmado por última vez — por la tienda, o por un comprador que estuvo allí.",
  "pitch.shopper3": "Alimentos cerca de su fecha de caducidad y stock de corta duración en un solo lugar, para que la buena comida se consuma en lugar de ser desechada.",
  "pitch.forShops": "Para tiendas",
  "pitch.shop1": "La lista es gratuita. Publicas una oferta, aparece en el mapa y en la página de tu ciudad.",
  "pitch.shop2": "Mueve stock que está cerca de la fecha en lugar de descartarlo.",
  "pitch.shop3": "Llena tus horas tranquilas con un descuento permanente que solo se aplica en la ventana que elijas.",
  "pitch.howTitle": "Cómo funciona",
  "pitch.how1": "Regístrate como tienda y coloca un pin donde realmente estás.",
  "pitch.how2": "Publica tu oferta — una foto, el precio y cuánto tiempo dura.",
  "pitch.how3": "Los compradores cercanos la ven, entran y muestran un código que verificas en la caja.",
  "pitch.startTitle": "Comienza con una oferta.",
  "pitch.startBody": "Escanea esto, regístrate y coloca una oferta en el mapa. Si nadie viene, has perdido dos minutos.",
  "pitch.qrStart": "Registra tu tienda",
  "pitch.exampleTitle": "Cómo se ve una semana en {city}",
  "pitch.exampleTag": "Ejemplo",
  "pitch.demoNote": "Los pines y listados arriba son ejemplos — {city} está abierta y esperando sus primeras tiendas.",
  "pitch.mapCaptionDemo": "Pines de ejemplo — así se ve un pueblo una vez que las tiendas comienzan a publicar.",
  "pitch.cityHeadingDemo": "{city} es el próximo en el mapa.",
  "pitch.citySubDemo": "LytePress está abriendo en {city}, {country}. Esto es lo que verán los compradores aquí — y cómo se vería tu propio anuncio.",
  "pitch.sellFreeN": "Gratis",
  "pitch.sellFree": "Para listar tus ofertas",
  "pitch.sellFastN": "2 min",
  "pitch.sellFast": "Para registrar tu tienda",
  "pitch.sellLiveN": "Hoy",
  "pitch.sellLive": "Tu primera oferta se publica",
  "pd.shortDatedHint": "Para productos cerca de su fecha de caducidad o mejor consumo - alimentos, bebidas, suplementos, medicamentos, cosméticos, aceite de motor, baterías, semillas, tinta. Los compradores ven una insignia de Fecha Corta; ser transparente lo vende más rápido y reduce el desperdicio.",
  "pc.giftedNote": "Regalado por nosotros. Los fechados se usan primero.",
  "pc.giftedHeld": "Extras regalados",
  "pc.giftedUseBy": "Usa {n} antes de {date}",
  "lo.title": "Un agradecimiento de LytePress",
  "lo.credits": "Ya tienes {n} ofertas extras en tu cuenta.",
  "lo.neverExpires": "Nunca expiran.",
  "lo.useBy": "Úsalos antes de {date}.",
  "lo.codeLine": "Y {off} de descuento en {what} con tu código.",
  "lo.codeValid": "Solo tuyo, un uso, hasta {date}.",
  "lo.useIt": "Úsalo",
  "lo.seePlans": "Ver planes",
  "lo.copy": "Copiar código",
  "lo.pkgPro": "Pro mensual",
  "lo.pkgProYear": "Pro anual",
  "lo.pkgElite": "Elite mensual",
  "lo.pkgEliteYear": "Elite anual",
  "lo.pendingTitle": "Un paquete elegido para tu tienda",
  "lo.pendingWhat": "Incluye {what}",
  "lo.pay": "Pagar {price}",
  "lo.paying": "Abriendo el pago…",
  "lo.invoiceMonthly": "{price} — facturación mensual, te enviaremos la factura.",
  "lo.payFailed": "No se pudo abrir el pago. Inténtalo de nuevo.",
  "lo.pkgPlan": "tu plan",
  "lo.titleSoon": "Solo quedan {n} días para usar esto",
  "vf.body": "Envíanos tus documentos comerciales y añadiremos una insignia azul de verificado a tu perfil. Los compradores confían más en las tiendas verificadas, y esto desbloquea cada categoría.",
  "vf.regPlaceholder": "Número de registro (opcional)",
  "qa.needs_verification": "Los descuentos de “{category}” solo pueden ser publicados por un negocio verificado. Verifícate desde Mi Cuenta — generalmente en un día.",
  "trust.verifiedBody": "Aprobado por nuestro equipo.",
  "trust.independentBody": "Aún no aprobado — pero muchos grandes vendedores locales comienzan aquí. Sus ofertas aún son revisadas por calidad.",
  "browse.nothingWithin": "Nada a menos de {radius} por ahora",
  "browse.nothingWithinMsg": "Ninguna oferta activa tiene un punto a menos de {radius} de ti. En lugar de llenar la página con tiendas a las que no puedes llegar, esta es la respuesta honesta, y dos formas de ampliar la búsqueda.",
  "browse.showFurther": "Ver {n} ofertas más lejanas",
  "browse.hideFurther": "Ocultar las ofertas más lejanas",
  "browse.furtherNote": "Están a más de {radius} de ti, las más cercanas primero.",
  "browse.browseCountry": "Ver todo el país",
  "mt.title": "Volvemos enseguida",
  "mt.body": "LytePress está en una actualización programada. Tu cuenta no se ve afectada: ofertas, créditos y códigos siguen exactamente donde los dejaste.",
  "mt.backIn": "Volvemos en",
  "mt.backAt": "Regreso previsto: {time}",
  "mt.soon": "Volvemos en cualquier momento.",
  "mt.staff": "Acceso del equipo",
  "mt.readonly": "Mantenimiento programado: puedes navegar, pero publicar y pagar están en pausa.",
  "mt.notice": "Mantenimiento programado {when}: el sitio podría no estar disponible brevemente.",
  "mt.adminOn": "El modo mantenimiento está ACTIVO: todos, excepto los administradores, están bloqueados.",
  "prc.usdNote": "Se factura en dólares estadounidenses. Si tu tarjeta está en otra moneda, tu banco aplica su propio tipo de cambio, por lo que tu estado de cuenta puede mostrar un importe ligeramente distinto.",
  "prc.feeNote": "Tu banco puede añadir comisiones por conversión de moneda o por transacción.",
  "lg.availabilityTitle": "Disponibilidad del servicio y mantenimiento programado",
  "lg.availabilityBody": "LytePress se actualiza con regularidad. Las actualizaciones de software y el mantenimiento se realizan a intervalos, y el acceso al sitio, la app o tu panel puede quedar temporalmente no disponible mientras se realiza ese trabajo.\n\nCuando el trabajo está planificado y es probable que interrumpa el servicio, procuramos avisar en la app con antelación y programarlo en horas de poca actividad. Los períodos breves de inactividad, planificados o no, son parte normal de un servicio en línea y por sí solos no dan derecho a un reembolso. Si un Boost o una colocación Destacada de pago no se ejecutó por una caída de nuestro lado, acreditamos o reembolsamos esa colocación: escribe a support@lytepress.com y lo resolvemos.",
  "lg.forceMajeureTitle": "Fuerza mayor",
  "lg.forceMajeureBody": "Ni tú ni LytePress son responsables por incumplir una obligación de estos términos cuando la causa está fuera de su control razonable. Esto incluye tormentas, huracanes, inundaciones, terremotos, incendios, epidemias o pandemias, guerra, disturbios civiles, huelgas, actos u órdenes de un gobierno o regulador, fallos del servicio eléctrico o de internet, y el fallo o la suspensión de un proveedor externo del que dependemos, como los de alojamiento, pagos, mapas o correo electrónico.\n\nMientras dure ese evento, las obligaciones afectadas quedan en pausa en lugar de incumplidas, y restableceremos el servicio normal tan pronto como sea razonablemente posible. Si un evento de este tipo mantiene el servicio caído más de 30 días seguidos, cualquiera de las partes puede terminar una suscripción de pago y reembolsaremos la parte no utilizada del período.",
};

export default es;
